import { TweenLite, TweenMax } from "gsap";
import * as PIXI from 'pixi.js';
import { IBackendSettingsService } from "../../../services/BackendSettingsService";
import { AddMouseDownListener, Color, CreateElement, Log, LogGroup, Point, Rect, Scale, SetStyles, Size, Timing } from "../.././MyHelpers";
import { AwardOptionPosition, ExpandingWildReelConfiguration, FreegamesCommonConfiguration, FreegamesEndAction, FreegamesSpinAction, FreegamesStartAction, ISimpleBonusAction, LineWin, PlayWindow, PlusOneFeatureConfiguration, PlusOneFeatureResult, ScatterRandomAwardConfiguration, ScatterRandomAwardResult, SharedJackpotWin, SimpleSlotGameState, SimpleTriggerResult, SlotGameBet, SlotGameMeta } from "../../api";
import { AudioManager, Track } from "../../AudioManager";
import { ClientState } from "../../ClientState";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { GameSession } from "../../GameSession";
import { Money } from "../../Money";
import { FontResource } from "../../ResourceManager/FontResource";
import { DecodedImageResource, ImageResource } from "../../ResourceManager/ImageResource";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../ResourceManager/VideoResource";
import { RobotPlay } from "../../RobotPlay";
import { service } from "../../services";
import { FillingPotFeature, JackpotDisplayType, Presentation, Settings } from "../../Settings";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SpinAnimParams } from "../../SpeedManager";
import { Translator } from "../../Translator";
import { ZIndex } from "../../ZIndex";
import { BigWinCountAnimation } from "../BigWinCountAnimation";
import { Bonus } from "../Bonus/Bonus";
import { SlotBonus } from "../Bonus/SlotBonus";
import { SlotBonusParams } from "../Bonus/SlotBonusParams";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkParam } from "../ExpandingWildBulk";
import { ExpandingWildsReel, ExpandingWildsReelParam } from "../ExpandingWildReel";
import { FillingPotGeneric } from "../FillingPot/FillingPotGeneric";
import { ActionStats } from "../IHistoyGame";
import { MyCanvas } from "../MyCanvas";
import { Panel } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { ScatterRandomAwardCreateParams, ScatterRandomAwardResults } from "../ScatterRandomAward/ScatterRandomAward";
import { ScatterRandomAwardPIXI } from "../ScatterRandomAward/ScatterRandomAwardPIXI";
import { ShakeAnimation } from "../ShakeAnimation";
import { SlotFeature } from "../SlotFeature";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusTotalResult, IBonusStartConfig, IRunResult, ITriggerResultDic, SlotGame, SymbolPosition } from "../SlotGame";
import { SlotGameMessages } from "../SlotGameScreenMessages";
import { ChangeSpeedParams } from "../SlotGameType1";
import { SlotGameType1Shared } from "../SlotGameType1Shared";
import { SlotSymbol } from "../SlotSymbol";
import { SlotSymbolSprite } from "../SlotSymbolSprite";
import { ReelMapper, ReelSymbolsToDisplay } from "../SpinAnimation/ReelMapper";
import { ReelSetMapper } from "../SpinAnimation/ReelSetMapper";
import { OnDeccelerationParams, ReelSpinAnimation } from "../SpinAnimation/ReelSpinAnimation";
import { SpinAnimation } from "../SpinAnimation/SpinAnimation";
import { SpinnableReels, SpinnableReelsParams } from "../SpinAnimation/SpinnableReels";
import { SpinnableReelsBigCanvas } from "../SpinAnimation/SpinnableReelsBigCanvas";
import { SpinTargetParams } from "../SpinAnimation/SpinTargetParams";
import { GameConfigurationJson, SymbolCollection } from "../SpineSymbols/SymbolsCollection";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { GetStateNameCallback, StateChange, StateMachine } from "../StateMachine";
import { ICanDrawSymbol, SpecificSymbolsAnimation, SymbolPositionToAnimate } from "../SymbolsAnimation";
import { ITransition } from "../Transition/ITransition";
import { ITransitionFactory, ITransitionParams } from "../Transition/ITransitionFactory";
import { TransitionFactory } from "../Transition/TransitionFactory";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
import { WinLineMarkers } from "../WinLineMarkers";
import { GenericWinLinesAnimation, WinLinesAnimationParams } from "../WinLines/GenericWinLinesAnimation";
import { WinSquareAnimations } from "../WinLines/WinSquaresAnimations";
import { IWinMessage, WinMessage, WinMessageAnimation } from "../WinMessage";
import { FreegameBonusPIXIAPP } from "./FreegameBonusPIXIAPP";
import { FreegameMessages } from "./FreegameMessages";
import { FreegamePickElement } from "./FreegamePickElement";
import { FreegameSession } from "./FreegameSession";
import { FreegameStates } from "./FreegameState";
import { GenericPlusOne, PlusOneParams } from "./GenericPlusOneAnimation";
import { IPlusOneFactory } from "./IPlusOneFactory";
import { SpritePlusOneFactory } from "./SpritePlusOneFactory";
import { FreegameBonusPIXIAPPResponsive } from "./FreegameBonusPIXIAPPResponsive";
import { IUniReelPIXIAPP } from "../UniReel/IUniReelPIXIPP";
// export interface FreegameBonusConfiguration extends ISimpleBonusConfiguration
// {
// 	ReelSet: number[][],
// 	Features: string[],
// 	MaxFreeGames: number,
// 	IntroAction: IntroAction;
//     FeatureConfigurations: IFeatureConfiguration[];
// }
export enum IntroAction
{
	Pick,
	NoPick,
}

export interface IFreeGameStartConfig extends IBonusStartConfig
{
	StartSpins:number;
}


export interface FreegameBonusParams extends SlotBonusParams {
	readonly gameResourcesBasePath: string;
    readonly gameBonusResourcesBasePath: string;
	readonly commonBonusResourcesBasePath: string;
	readonly reelAnimationParams: SpinAnimParams;
	readonly winAnimationSpeedFactor: number;
	readonly uniReelPixiApp?: IUniReelPIXIAPP

	
	
	//readonly picks: number;

	// screen size in pixels
	readonly screenSize: Size;

	// size of slot window in number of symbols
	readonly windowSymbolSize: PlayWindow;

	// position and size of slot window in pixels
	readonly windowRectangle: Rect;

	readonly availableSymbols: SlotSymbol[];
    readonly availableSymbolsMap: Map<string, SlotSymbol>;

	// sprite animations of symbols
	readonly symbolSpriteAnims: SlotSymbolSprite[];
	readonly symbolSpriteAnimsByName: Map<string, SlotSymbolSprite>;
	

	// 
	readonly playlines: number[][];

	// reel set
	// readonly reelSet: number[][];

	// where to set reels at on start
	readonly startPositions: number[];

	//
	readonly audio: AudioManager;

	readonly panel: Panel;

	readonly lines: number;

	readonly denom: number;

	readonly bonusConfiguration: FreegamesCommonConfiguration;

	readonly pickElementFactory: IFreegameBonusPickElementFactory;

	readonly linesPlayed: number;

	readonly clientState:ClientState;
	readonly translator:Translator;

	//readonly basegameWinCents: number;
	readonly robotPlay: RobotPlay;

	readonly slotGameMeta:SlotGameMeta;
	readonly slotGameInitData: SlotGameInitData;
	readonly slotGame: SlotGame;

	readonly jackpotRequired : boolean;

	readonly color: RewardColor;
	readonly bonusList: Map<Bonus, SlotBonus>;	
	readonly pixiSpritesByName : Map<string, any[]>;
	readonly spinnableReelsParams : SpinnableReelsParams;
	readonly reelBackgroundTexture : PIXI.Texture,
	readonly reelBackgroundMaskTexture : PIXI.Texture
	readonly colorLineMarkers : MarkersInfoColors,
	readonly initData: SlotGameInitData;
	readonly skinAttachmentFillingPotFeature : number;
	readonly symbolCollection? : SymbolCollection;
	readonly gameConfig : GameConfigurationJson ;
	readonly backendSettings: IBackendSettingsService
}

export class FreegamePickElementParams
{
	public index: number;
	public logGroup: LogGroup;
	public displayRect: Rect;
	public pickRect: Rect;
	public awardRect: Rect;
	public sprite: CanvasSprite;

	public constructor(
		index: number,
		logGroup: LogGroup,
		displayRect: Rect,
		pickRect: Rect,
		awardRect: Rect,
		sprite: CanvasSprite
	)
	{
		this.index = index;
		this.logGroup = logGroup;
		this.displayRect = displayRect;
		this.pickRect = pickRect;
		this.awardRect = awardRect;
		this.sprite = sprite;
	}
}


export interface FreegamePick {
	Award: number;
}

export interface FreegamePickRevealValue extends BonusPickReveal {
	RevealedValue: FreegamePick;
}

export interface FreegameBonusRevealRemaining extends BonusRevealRemaining {
	//Remaining: FreegamePick[];
	Remaining: any;
}

export interface FreegameRunResult extends IRunResult {
	Anticipation: number;
	Bonus: string;
    BonusWin: Money;
	FeatureResults: any;
	FeaturesTriggered: number;
    JackpotHit: never;
	LineCount: number;
	Lines: LineWin[];
    NextBonus: never
	Played: number;
	ReelStops: number[];
    RunWin: Money;
    RunsPlayed: number;
    RunsRemaining: number;
    RunsStarted: number;
	Remaining: number;
	TotalWin: Money;
	TriggerResults: ITriggerResultDic;
}

/* export interface ITriggerResultDic
{
	[key: string] : TriggerResult,
}

export interface TriggerResult
{
	willTrigger:boolean;
    anticipation:number;
    count: number;
    symbolsTriggered: SymbolPosition[];
} */


export class FreegamePickElemGeometry {
	public displayRect: Rect = null;
	public pickRect: Rect = null;
	public awardRect: Rect = null;

	public constructor(displayRect: Rect, pickRect: Rect = null, awardRect: Rect = null) {
		this.displayRect = displayRect;

		if (pickRect) {
			this.pickRect = pickRect;
		}
		else {
			this.pickRect = this.displayRect;
		}

		if (awardRect) {
			this.awardRect = awardRect;
		}
		else {
			this.awardRect = this.pickRect;
		}
	}
}

export enum FreegameBonusContainer
{
	IntroMessage,
	NoPickIntro,
	Picks,
	PickedMessage,
	Reels,
	FinalMessage
}


export class FreegameBonus extends SlotBonus implements Resourceful2, ICanDrawSymbol
{
	public override OnResize(): void {
		throw new Error("Method not implemented.");
	}
	public override CreateTransitionPixi(app? : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}
	public OnPicked(pickIndex: number): void {
		throw new Error("Method not implemented.");
	}
	public OnBonusPickElement(pickElement: BonusPickElement): void {
		throw new Error("Method not implemented.");
	}
	public OnBonusPickReveal(pickReveal: BonusPickReveal): void {
		throw new Error("Method not implemented.");
	}
	public OnBonusRevealRemaining(revealRemaining: BonusRevealRemaining): void {
		throw new Error("Method not implemented.");
	}
	
	protected readonly params: FreegameBonusParams;
	protected view: HTMLElement = null;
	protected readonly basepath: string;

	protected session: FreegameSession = null;

	protected noPickintroMessageContainer: HTMLElement = null;
	protected reelsContainer: HTMLElement = null;
	protected finalMessageContainer: HTMLElement = null;

	protected containers: Map<FreegameBonusContainer, HTMLElement> = new Map<FreegameBonusContainer, HTMLElement>();

	//protected pickElem: HTMLElement = null;

	//protected containers: HTMLElement[] = [];

	//private logGroup: string = "FreegameBonus";
	protected stateMachine: StateMachine<FreegameStates> = new StateMachine<FreegameStates>(FreegameStates.Idle, this.logGroup, (state: FreegameStates) => FreegameStates[state]);

	// REELS
	protected spinnableReels: SpinnableReelsBigCanvas = null;
	protected spinAnimation: SpinAnimation = null;
	protected reelSetMapper: ReelSetMapper = null;

	// WIN LINES AND MARKERS
	protected winLinesAnimation: GenericWinLinesAnimation= null;
	private winLineMarkers: WinLineMarkers = null;

	// EXPANDING WILD FEATURE
	protected features: Map<string, SlotFeature> = new Map<string, SlotFeature>();
	//private expandingWildsBulk: ExpandingWildsBulk = null;

	// +1 FREEGAME FEATURE
	protected plusOneAnimFactory: IPlusOneFactory = new SpritePlusOneFactory();
	protected plusOneAnim: GenericPlusOne = null;
	protected plusOneTarget: Point = new Point(Scale.X(500), Scale.Y(-250));

	// spin delay, in millis
	//private autoSpinTimer: SingleShotTimer= new SingleShotTimer(() => this.AutoSpin(), 3000);
	private autoSpinTimer: number = null;
	
	//
	private lastSpinResult: FreegameRunResult = null;

	// win lines or colelct can be interrupted, 
	// when interrupted, start new spin right away 
	private spinInterrupted: boolean = false;

	protected winCreditAnimation: TweenMax = null;
	protected winValues: any = {balance:0,win:0};

	//protected symbolsAnimation: SymbolsAnimation = null;

	protected symbolsAnimation: SpecificSymbolsAnimation = null;

	protected winMessageAnimation: WinMessageAnimation = null;
	protected shakeAnimation: ShakeAnimation = null;
	//protected fountainAnimation: FountainAnimation = null;
	protected bigWinCountAnimation: BigWinCountAnimation = null;

	protected panel: Panel;


	private lineMessage: HTMLElement = null;
	//private denomMessage: HTMLElement = null;

	//private transition: SceneTransition = null;

	protected audio: AudioManager = null;

	protected override parentresid: ResourceIdentifier = null;
	//protected resid: ResourceIdentifier = null;
	//protected screenProtocol: ScreenProtocol = null;
	//protected screenProtocolScope: ScreenProtocolScope = null;

	private lineMessageLeft: HTMLElement = null;
	private lineMessageRight: HTMLElement = null;

	protected clientState: ClientState = null;
	protected translator: Translator;

	protected robotPlay: RobotPlay;

	protected demoMessage:HTMLElement = null;

	//ADD VIDEO TRANSITION
	//protected transitionView:HTMLElement=null;
	//protected videotransition:HTMLVideoElement=null;

	//CREATE DIV TO TITLE 
	//protected titleSrpite:HTMLElement=null;
	protected titleSprite: CanvasSprite = null;
	protected VoicePlay:boolean=true;

	protected spinnableReelsParams: SpinnableReelsParams = {};
	protected systemContext: ISystemContext = null;

	//add new transition 
	protected transitionView: ITransition = null;
	protected transitionViewFactory:ITransitionFactory= new TransitionFactory();
	
	protected wins: IWinMessage[] = [
		{name: "big", winMultiplier: 10,file: "big_win_966x185_half"},
		{name: "great", winMultiplier: 20, file: "great_win_1013x277_half"},
		{name: "huge", winMultiplier: 30, file: "huge_win_966x202_half"},
		{name: "awesome", winMultiplier: 40, file: "awesome_win_1119x213_half"},
		{name: "amazing", winMultiplier: 50, file: "amazing_win_1185x252_half"}
	];
	//protected bigSymbolAnim: BigSymbolAnim = null;

	protected BonusName(): string
	{
		return "FreeGameBonus";
	}
	//Create some canvas for button text dialog
	protected buttonStartCanvas: MyCanvas;
	protected buttonExitCanvas: MyCanvas;
	//add BigBackground 
	protected backgroundFreeGameBonus: HTMLElement = null;

	//add ScatterRandomAward 
	protected scatterRandomAwardFeature: ScatterRandomAwardPIXI = null;
	protected bonusList: Map<Bonus, SlotBonus> = new Map<Bonus, SlotBonus>();

	//add cache symbol 
	//protected symbolCache: SymbolCache;

	//create interval for freegames
	protected timeoutAutoSpinFreeGames : ITimeout;
	protected timeoutStopsAnim : ITimeout;
	protected timeoutFreeGameWin : ITimeout;
	protected timeoutFreeGameFinalMessage : ITimeout;
	protected timeoutShowBonusIntoBonus : ITimeout;
	protected maxAdditionalFreegames : number;
	protected winLinesAnimFactor: number;
	//protected jackpotSharedShow : JackpotSharedShow = null;

	public constructor(gameName: string, params: FreegameBonusParams ) 
	{
		super(gameName, params);

		this.session = new FreegameSession();
		this.winLinesAnimFactor = params.winAnimationSpeedFactor;

		this.parentresid = params.resid;
		//this.translator=translator;
		this.translator=params.translator;
		//this.resid = params.resid.Add("FreeGameBonus");

		//this.screenProtocol = params.screenProtocol;
		//this.screenProtocolScope = params.screenProtocolScope.Add("FreeGameBonus");

		this.panel = params.panel;
		this.params = params;
		this.audio = params.audio;
		this.clientState = params.clientState;
		this.systemContext = params.systemContext.CreateSubContext("FreeGameBonus");
		this.bonusList = params.bonusList;
		

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add("FreegameBonus");

		this.lineMessage = document.createElement("div");
		this.lineMessage.classList.add("line-message");

		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/";


		this.backgroundFreeGameBonus = CreateElement("div",{
			classes:[this.resid.Scope(), "BackgroundBigFreeGame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: Scale.Hpx(1080*this.ScreenNumberConfiguration),
				position: "absolute",
				bottom: Scale.Ypx(0),				
				backgroundSize: "100%",
				//zIndex:ZIndex.BackgroundBonus+"",
			}
		});

		if(params.slotGameMeta.Demo == true)
		{
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
			{
				position:"absolute",
				top:"8%",
				left:"86%",
				width:"16%",
				height:"8%",
				fontSize:"99px",
				letterSpacing:"5px",
				fontFamily:"NotoSansDisplay-ExtraBold",
				color:"rgba(255, 0, 0, 1)",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				transform: "rotate(45deg)",
			})
			
			this.demoMessage.innerHTML = "DEMO";
		}


		

		this.maxAdditionalFreegames =  (this.params.bonusConfiguration.FeatureConfigurations.find(feature => feature.FeatureType == "PlusOneFeature" ) as PlusOneFeatureConfiguration )?.MaxAdditionalFreegames ?? 10;		
		//this.denomMessage = document.createElement("div");
		//this.denomMessage.classList.add("denom-message");

		this.stateMachine.SetCallback(FreegameStates.IntroTransition, StateChange.Begin, () => this.OnIntroTransitionBegin());
		this.stateMachine.SetCallback(FreegameStates.IntroTransition, StateChange.End, () => this.OnIntroTransitionEnd());


		//////// intro with pick options
		this.stateMachine.SetCallback(FreegameStates.IntroMessage, StateChange.Begin, () => this.OnIntroMessageBegin());
		this.stateMachine.SetCallback(FreegameStates.IntroMessage, StateChange.End, () => this.OnIntroMessageEnd());

		// this.stateMachine.SetCallback(FreegameStates.Pick, StateChange.Begin, () => this.OnPickBegin());
		// this.stateMachine.SetCallback(FreegameStates.PickedMessage, StateChange.Begin, () => this.OnPickedMessageBegin());
		// this.stateMachine.SetCallback(FreegameStates.PickedMessage, StateChange.End, () => this.OnPickedMessageEnd());
		//////////////////////

		////////// intro without pick options
		this.stateMachine.SetCallback(FreegameStates.NoPickIntro, StateChange.Begin, () => this.OnNoPickIntroMessageBegin());
		this.stateMachine.SetCallback(FreegameStates.NoPickIntro, StateChange.End, () => this.OnNoPickedMessageEnd());

		/////////////////////

		this.stateMachine.SetCallback(FreegameStates.WaitFirstSpin, StateChange.Begin, () => this.OnWaitFirstSpinBegin());
		//this.stateMachine.SetCallback(FreegameStates.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(FreegameStates.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(FreegameStates.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(FreegameStates.Features, StateChange.Begin, () => this.OnFeaturesBegin());
		this.stateMachine.SetCallback(FreegameStates.Features, StateChange.End, () => this.OnFeaturesEnd());

		this.stateMachine.SetCallback(FreegameStates.BigWin, StateChange.Begin, () => this.OnBigWinBegin());
		this.stateMachine.SetCallback(FreegameStates.BigWin, StateChange.End, () => this.OnBigWinEnd());

		this.stateMachine.SetCallback(FreegameStates.Win, StateChange.Begin, () => this.OnWinBegin());
		this.stateMachine.SetCallback(FreegameStates.Win, StateChange.End, () => this.OnWinEnd());


		this.stateMachine.SetCallback(FreegameStates.Collect, StateChange.Begin, () => this.OnCollectBegin());

		this.stateMachine.SetCallback(FreegameStates.Bonus, StateChange.Begin, () => this.OnBonusBegin());
		this.stateMachine.SetCallback(FreegameStates.Bonus, StateChange.End, () => this.OnBonusEnd());

		
		this.stateMachine.SetCallback(FreegameStates.SpinIdle, StateChange.Begin, () => this.OnSpinIdleBegin());
		this.stateMachine.SetCallback(FreegameStates.SpinIdle, StateChange.End, () => this.OnSpinIdleEnd());

		this.stateMachine.SetCallback(FreegameStates.FinalMessage, StateChange.Begin, () => this.OnFinalMessageBegin());
		this.stateMachine.SetCallback(FreegameStates.FinalMessage, StateChange.End, () => this.OnFinalMessageEnd());

		this.stateMachine.SetStateChangeCallback( (oldState: FreegameStates, newState: FreegameStates, stateNameCallback: GetStateNameCallback<FreegameStates>) => {
			// Log.Debug(this.logGroup, "Changing state " + stateNameCallback(oldState) + " to " + stateNameCallback(newState));
		});
		this.robotPlay = params.robotPlay;

		this.timeoutAutoSpinFreeGames = this.systemContext.TimingContext().CreateTimeout("timeoutAutoSpinFreeGames", 2000, () => {
			this.AutoSpin()
		})

		this.timeoutStopsAnim = this.systemContext.TimingContext().CreateTimeout("timeoutStopsAnim", 4000, () => {
			try {
				this.spinnableReels.StopSymbolsAnim();
				//this.currentBonus.TriggerAnimationStopped();
				//this.DisableSymbolsAnimation();
			} catch (error) {
				Log.Error(this.logGroup, "Error stops symbol", error);
			}
		});

		this.timeoutFreeGameWin = this.systemContext.TimingContext().CreateTimeout("timeoutFreeGameWin", 2000, () => {
			this.audio.Stop(this.parentresid.ScopedResourceName("bigwin"));
			this.shakeAnimation.Stop();
			this.stateMachine.ChangeState(FreegameStates.Win);
		});

		this.timeoutFreeGameFinalMessage = this.systemContext.TimingContext().CreateTimeout("timeoutFreeGameFinalMessage", 1000, () => {			
			this.stateMachine.ChangeState(FreegameStates.FinalMessage);			
		});		

		let timeoutShowBonusIntoBonus = 0;
		if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
			//if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) this.jackpotSharedShow = new JackpotSharedShow(this.audio , this.resid);	
			this.skinAttachmentFillingPotFeature = params.skinAttachmentFillingPotFeature;
			this.CreateFillingPot();
			timeoutShowBonusIntoBonus += 3600;
		}	

		

		this.timeoutShowBonusIntoBonus = this.systemContext.TimingContext().CreateTimeout("", timeoutShowBonusIntoBonus, () => {
			this.fillingPotFeature?.StopAnim();							
			this.audio.Stop(this.resid.ScopedResourceName("background"));			
			this.OnBonusRunFinished(this.nextBonusData);
			this.nextBonusData = null;					
		});		

		
	}

	protected fillingPotUpdate : ITimeout = null;
	protected fillingPotHitBonues : ITimeout = null;
	//protected fillingPotFeature: FillingPotGeneric = null;
	protected skinAttachmentFillingPotFeature : number = 1;
	protected CreateFillingPot() {
		
		this.fillingPotFeature = new FillingPotGeneric({
			systemContext: this.systemContext, 
			initData: this.params.initData,
			resid: this.resid,			
			logGroup: this.logGroup,			
			//viewSize: this.viewSize,
			gameResourcesBasePath :  this.basepath + "resources/", 	
			commonResourcesPath :  this.params.commonBonusResourcesBasePath + "resources/FillingPot/",     
			//EnabledBets: this.initData.EnabledBets,FillingPotvPopet
			gameName : this.gameName,
			audio : this.audio,
			skinAttachment : this.skinAttachmentFillingPotFeature,
			windowRectangle : this.params.windowRectangle,
			clientState : this.params.clientState,
			//poppetPlusPot : this.params.gameConfig.poppetPlusPot != null ? this.params.gameConfig.poppetPlusPot : false
		});		

		this.fillingPotUpdate = this.systemContext.TimingContext().CreateTimeout("fillingPotUpdate", 100, () => {
			// //search sra position and save for send to spine 			
			//let ScatterRandomAward = (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)
			this.fillingPotFeature?.StartIncrement({
				BonusWin: false,
				ScatterCordinates: (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPositionThisSpin,
				winSymbols : this.simpleLastBonusAction.SpinWithFeatures.ExpectedSymbols,
				
			});
		});

		this.fillingPotHitBonues = this.systemContext.TimingContext().CreateTimeout("fillingPotUpdate", 500, () => {
			// this.fillingPotFeature?.StartIncrement({
			// 	BonusWin: true,
			// 	ScatterCordinates: null
			// })

			// let bonusName : string = "";
			// this.lastSpinAction.Triggers.forEach(bonusTriggerResult => {
			// 	BonusWillUpdateFillingPotFeature.forEach(b => {
			// 		if (b == bonusTriggerResult.Bonus && bonusTriggerResult.WillTrigger == true) {
			// 			//change true bonus win for play all anim whit spine on FillingPotFeature 						
			// 			bonusName = b;
			// 			this.fillingPotFeature?.StartBonusWin(bonusName);			
			// 		}else if(bonusTriggerResult.WillTrigger == true){
			// 			bonusName = "Freegames"
			// 			this.fillingPotFeature?.StartBonusWin(bonusName);		
			// 		} 					
			// 	})
			// });
			
			
		});
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		await this.fillingPotFeature?.PrepareResources(loadingStage, resourceManager);
		// await SlotGameType1Shared.Instance().ResourcesPrepare(loadingStage, resourceManager , this.params.jackpotRequired);

		if (loadingStage == LoadingStage.GamesPreload)
		{

		}
		else if (loadingStage == LoadingStage.Games)
		{
			

			await this.BasePrepare(resourceManager);

			//Background and Construct Reels
			await this.PrepareBackgroundReel(resourceManager);

			await this.ConstructReels(resourceManager);

		let params:PlusOneParams={
			viewSize: this.params.screenSize,
			spinnableReels: this.spinnableReels,
			logGroup: this.logGroup,
			resid: this.resid,
			bonusName: this.bonusName,
			maxAdditionalFreegames: this.maxAdditionalFreegames,
			gameBonusResourcesBasePath: this.params.gameBonusResourcesBasePath,
			commonBonusResourcesBasePath: this.params.commonBonusResourcesBasePath
		};

			this.plusOneAnim = this.plusOneAnimFactory.CreatePlusOne(params);	
			//this.bigSymbolAnim = new BigSymbolAnim(this.params.availableSymbolsMap, this.spinnableReels);

			/*
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transition")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/plusonemove" + Settings.audioFormat, this.resid.ScopedResourceName("plusonemove")));
			*/
			await this.PrepareWinLines(resourceManager);
			await this.AudioPrepare(resourceManager);

			await this.FeaturesPrepare(resourceManager);
			await this.BigWinPrepare(resourceManager);

			await this.PrepareHistory(resourceManager);

			//await this.jackpotSharedShow?.PrepareResources(resourceManager);
		}
	}

	public AudioPrepare(resourceManager: IWriteOnlyResourceManager)
	{ 
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transitionaudio")));
		//this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/plusonemove" + Settings.audioFormat, this.resid.ScopedResourceName("plusonemove")));
	    this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/final" + Settings.audioFormat, this.resid.ScopedResourceName("final")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegameintro" + Settings.audioFormat, this.resid.ScopedResourceName("intro")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("freegame")));		

		for (let i = 0; i < this.wins.length; i++) {
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/voice/"+this.wins[i].name + Settings.audioFormat, this.resid.ScopedResourceName(this.wins[i].name)));
		}
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/reelSpinStop"+Settings.audioFormat, this.resid.ScopedResourceName("reelstop")));
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {

		await this.fillingPotFeature?.ResourcesLoaded(loadingStage, resourceManager);
		// SlotGameType1Shared.Instance().ResourcesLoaded(loadingStage, resourceManager , this.params.jackpotRequired);

		if (loadingStage == LoadingStage.GamesPreload)
		{

		}
		else if (loadingStage == LoadingStage.Games)
		{
			//this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;

			await this.BaseLoaded(resourceManager);

			

			//this.PrepareMessage(resourceManager);
			this.SetContainers(resourceManager);

			this.LoadedHistory(resourceManager);


		
			// WIN LINES AND MARKERS
			//this.winLines = new WinLines(this.params.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.params.playlines);
			//this.winLinesAnimation = new WinLinesAnimation(this.winLines/* , this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 2 * 1000 */);


			await this.winLinesAnimation.ResourcesLoaded(resourceManager);

			// // WIN LINES AND MARKERS view
			this.reelsContainer.appendChild(this.winLinesAnimation.View());
			this.reelsContainer.appendChild(this.winLineMarkers.LeftView());
			this.reelsContainer.appendChild(this.winLineMarkers.RightView());


			this.symbolsAnimation = new SpecificSymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper, this);

			//this.symbolsAnimation = new SymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper);

			await this.FeaturesLoaded(resourceManager);


			this.BigWinLoaded(resourceManager);

			//this.bonusTriggerAnimation = new SpecificSymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper, this);

			// this.View().querySelector(".header").appendChild(this.translator.Anchor(() => this.translator.t.fregameheader));
			// this.View().querySelector("#contents1").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage1));
			// this.View().querySelector(".bonusName").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage3));
			// this.View().querySelector("#contents2").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage2));
			// this.View().querySelector("#contents3").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage4));

			// this.View().querySelector(".startbut").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage5));

			if(this.params.slotGameMeta.Demo == true)
			{
				this.view.appendChild(this.demoMessage);
			}

			//this.TitleLoaded(resourceManager);
			this.reelsContainer.appendChild(this.plusOneAnim.View());


			
			// //reels resources prepare Texture for pixi.js			
			let reelImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reel", "image"]));				
			let reelBackgroundTexture = PIXI.Texture.from(reelImageResource.DecodedImage());
			

			let reelImageMaskResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelMask", "image"]));	
			let reelBackgroundMaskTexture = PIXI.Texture.from(reelImageMaskResource.DecodedImage());		

			this.spinnableReels.ResourcesLoaded(this.params.pixiSpritesByName , reelBackgroundTexture, reelBackgroundMaskTexture);
			await this.LoadedFillingPot(resourceManager);
			this.LoadedReels();
			// REELS
			this.reelsContainer.appendChild(this.spinnableReels.GetView());

			//this.symbolCache = new SymbolCache(this.params.symbolSpriteAnimsByName, this.spinnableReels.GetSymbolSize(), this.resid);

			//await this.jackpotSharedShow?.ResourcesLoaded(resourceManager);
		}
	}

	//create FillingPot 
	protected async LoadedFillingPot(resourceManager: IReadOnlyResourceManager) {
		if (!this.fillingPotFeature)
		{
			// not enabled;
			return;
		}
		
		this.view.appendChild(this.fillingPotFeature?.View());
			// redraw reels when context recovers
		this.fillingPotFeature.OnCreatedCallback = () => {
			//console.log("CallBackForFillingPot");
			this.spinnableReels.Create(this.fillingPotFeature?.GetReelContainer());
			//this.jackpotSharedShow.Create();
			//this.fillingPotFeature.GetReelContainer().addChild(this.jackpotSharedShow.View());
			//this.ReelsRestored();
		};
		this.fillingPotFeature.OnDestroyCallback = () => {
			//console.log("CallBackForFillingPot");
			this.spinnableReels.Destroy("FreegameBonus.FillingPotFeature.OnDestroyCallback");
			//this.ReelsRestored();
			//this.jackpotSharedShow.Destroy();
		};
	}


	protected SetContainers(resourceManager: IReadOnlyResourceManager): void
	{
		this.PrepareNoPickIntroMessage(resourceManager);
		this.PrepareFinalMessage(resourceManager);
		this.PrepareReelsContainer(resourceManager);
		this.containers.set(FreegameBonusContainer.NoPickIntro, this.noPickintroMessageContainer);
		this.containers.set(FreegameBonusContainer.Reels, this.reelsContainer);
		this.containers.set(FreegameBonusContainer.FinalMessage, this.finalMessageContainer);
	}
	//Create TextCanvas for button start and end bonus
	protected ButtonCanvasText() : MyCanvas
	{
		let buttonText = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
			style: {
				left: Scale.Xpx(8),
				top: Scale.Ypx(12),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin
			}
		});

		return buttonText;
		
	}
	//protected fontHeight:number=Scale.fh(135);
	public SetTextCanvas(text: string, canvas: MyCanvas , fontHeight:number=Scale.fh(135))
	{
		canvas.context.clearRect(0, 0, canvas.size.Width,canvas.size.Height);

		let gradient = canvas.context.createLinearGradient( 
			canvas.size.Width / 2, 
			canvas.size.Height / 2 - fontHeight/2, 
			canvas.size.Width / 2, 
			canvas.size.Height /2 + fontHeight/2
		);

		gradient.addColorStop(0,    "#F2E416");
		gradient.addColorStop(0.25, "#F2BE22");
		gradient.addColorStop(0.50, "#C2760E");
		gradient.addColorStop(0.75, "#F2BE22");
		gradient.addColorStop(1,    "#F2E416");

		canvas.context.fillStyle = gradient;

		canvas.context.font = "bold " + fontHeight + "px " + this.resid.ScopedResourceName("bigwincount") ;
		canvas.context.textBaseline = "middle";
		canvas.context.textAlign="center";
		canvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		canvas.context.miterLimit = 2;

		canvas.context.strokeStyle = "black";
		canvas.context.lineWidth = Scale.fh(10);
		canvas.context.strokeText(text, canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.context.strokeText(text, canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.context.fillText(text,   canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.RestoreContext();

		text = null;
		gradient = null;		
	}

	protected PrepareNoPickIntroMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.noPickintroMessageContainer = CreateElement("div", {classes:["noPickintroMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"relative",
				top:"0px",
				left:"0px",
				width:"100%",
				height:"100%",
				zIndex:ZIndex.BonusCofirmMessage.toString(),
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["noPickMessageContainer"], parentToAppend: this.noPickintroMessageContainer,
			style:
			{
				width:"100%",
				height:"100%",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				fontFamily: this.resid.ScopedResourceName("font"),
			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
				{
					position:"relative",
					width: Scale.Hpx(1152),
					height:Scale.Wpx(648),
					backgroundSize: "contain",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				}
		});

		let freeGameSymbolFGMessageSpanish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "spanish"])).CssBackground(),


			}
		});
		let freeGameSymbolFGMessageEnglish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "english"])).CssBackground(),


			}
		});
		
		dialog.appendChild(this.translator.Anchor(()=> this.translator.t.BigFG(freeGameSymbolFGMessageSpanish.outerHTML, freeGameSymbolFGMessageEnglish.outerHTML)));
		

		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom: Scale.Ypx(-50),
				width:"100%",
				height: Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width:Scale.Wpx(600),
				height:Scale.Hpx(300),
				fontSize:Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});

		//button.appendChild(this.translator.Anchor(()=> this.translator.t.freegameStart));
		this.buttonStartCanvas = this.ButtonCanvasText();		
		this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);
		button.appendChild(this.buttonStartCanvas.View());
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas));
	
	


		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == FreegameStates.NoPickIntro) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});

	}

	protected PrepareFinalMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.finalMessageContainer = CreateElement("div", {classes:["finalMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"relative",
				top:"0px",
				left:"0px",
				width:"100%",
				height:"100%",
				zIndex:ZIndex.BonusCofirmMessage.toString(),
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["messageContainer"], parentToAppend: this.finalMessageContainer,
			style:
			{
				width:"100%",
				height:"100%",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				fontFamily: this.resid.ScopedResourceName("font"),

			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
				{
					position:"relative",
					width:  Scale.Wpx(1152),
					height: Scale.Hpx(648),
					backgroundSize: "contain",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				}
		});

		// let message: HTMLElement = CreateElement("div", {classes:["message"], parentToAppend:dialog, style:{position:"relative", top:"35px", fontSize:"50px", height:"50%", textAlign:"center"}});
		// let finished: HTMLElement = CreateElement("div", {classes:["congratulations"], parentToAppend:message, style:{height:"100px", fontSize:"90px"}});
		// let youHaveWon: HTMLElement = CreateElement("div", {classes:["youHaveWon"], parentToAppend:message});
		// let creditsCont: HTMLElement = CreateElement("div", {classes:["creditsCont"], parentToAppend:message, });
		// let bonusCredits: HTMLElement = CreateElement("span", {classes:["bonusCredits"], parentToAppend:creditsCont, style:{fontSize:"90px"}});
		// let CreditsTxt: HTMLElement = CreateElement("div", {classes:["CreditsTxt"], parentToAppend:message});
		// let pressExit: HTMLElement = CreateElement("div", {classes:["pressExit"], parentToAppend:message});

		// finished.appendChild(this.translator.Anchor(() => this.translator.t.freeGameFinished));
		// youHaveWon.appendChild(this.translator.Anchor(() => this.translator.t.freeGameYouHaveWon));
		// //creditsCont.appendChild(this.translator.Anchor(() => this.translator.t.freegameFreegame));
		// //bonusCredits.appendChild(this.translator.Anchor(() => this.translator.t.freegameBonus));
		// CreditsTxt.appendChild(this.translator.Anchor(() => this.translator.t.freeGameCredits));
		// pressExit.appendChild(this.translator.Anchor(()=> this.translator.t.freeGamePressExit));

		let freeGameSymbolFGMessageSpanish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "spanish"])).CssBackground(),


			}
		});
		let freeGameSymbolFGMessageEnglish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "english"])).CssBackground(),


			}
		});
		
		dialog.appendChild(this.translator.Anchor(()=> this.translator.t.BigFG(freeGameSymbolFGMessageSpanish.outerHTML, freeGameSymbolFGMessageEnglish.outerHTML)));

		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom:  Scale.Ypx(-50),
				width:"100%",
				height:  Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(300),
				fontSize: Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});

		//button.appendChild(this.translator.Anchor(()=> this.translator.t.freegameExit));
		this.buttonExitCanvas = this.ButtonCanvasText();		
		this.SetTextCanvas(this.translator.t.freegameExit, this.buttonExitCanvas);
		button.appendChild(this.buttonExitCanvas.View());
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.freegameExit, this.buttonExitCanvas));
		


		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == FreegameStates.FinalMessage) {		
				//this.CreateTransitionPixi();		
				//SHOW VIDEO TRANSITION				
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});
	}

	protected PrepareReelsContainer(resourceManager: IReadOnlyResourceManager):void
	{
		this.reelsContainer = CreateElement("div",{classes:["reelsContainer"], parentToAppend:this.view,
			style:{
				width:"100%",
				height:"100%",
				top:"0px",
				position : "absolute",
			}
		})
	}

	//Put Title Freegame in funcion to overwrite
	public TitleLoaded(resourceManager:ResourceManager)
	{		
		// this.titleSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("freegametitle")).sprite, canvasSize: new Size(1920, 400)});				
		// this.titleSprite.Update();
		// //this.titleSprite.canvas.view.style.zIndex = ""+ ZIndex.FreeGameIntroText;
		// this.titleSprite.canvas.view.style.position="absolute";
		// //this.titleSprite.canvas.view.style.top="1287px";
		// this.titleSprite.canvas.view.style.top="-873px";
		//this.view.appendChild(this.titleSprite.View());
	}

	
	

	protected BasePrepare(resourceManager: IWriteOnlyResourceManager): void {
		//resourceManager.Add(new HTMLResource(this.params.commonBonusResourcesBasePath +  "FreegameBonus.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.params.commonBonusResourcesBasePath +  "FreegameBonus.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		this.PrepareFonts(resourceManager);
		this.BackgroundPrepare(resourceManager);
		
		resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.jpg", this.resid.ScopedResourceName(["background", "image"])));
		
		
		resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));
	
		this.PrepareTransition(resourceManager);	

		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));

	}

	//PREPARE TITLE FOR TRANSITION 
	public PrepareTransition(resourceManager: IWriteOnlyResourceManager) {
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("freegame")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/transitionLight" + Settings.audioFormat, this.resid.ScopedResourceName("transitionLight")));
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/freegame3d", ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic"), true, LogGroup.Global.Add("TitleTransition").Add("FreegameClassic"), true));
		let pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/Background_" + this.ScreenNumberConfiguration + "S";
		//Overwrite this video path because for this jackpots need different 
		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
			pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + this.ScreenNumberConfiguration + "s";
		}

		if (Settings.PresentationType == Presentation.VideoGameSprite) {
			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				src: pathVideo,
				unloadOnHide: true
			}));
		}
		else if (Settings.PresentationType == Presentation.Image) {
			let pathImgTransition = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundTransition_" + this.ScreenNumberConfiguration + "S.png";
			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
				pathImgTransition = `${this.params.gameResourcesBasePath}resources/BackgroundTransition_${this.ScreenNumberConfiguration}S.png`;
			}
			resourceManager.AddGlobal(new ImageResource(pathImgTransition,
				ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + this.ScreenNumberConfiguration).Scope()));
			//debugger
		}
		else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
			pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundVideoSprite_" + this.ScreenNumberConfiguration + "S";
			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				src: pathVideo,
				unloadOnHide: true
			}));
		}
		else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
			pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundCommonVideo_" + this.ScreenNumberConfiguration + "S";
			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				logGroup: LogGroup.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				src: pathVideo,
				unloadOnHide: true
			}));
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
			resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
			// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
			// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
			resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
			// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
			// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
		}
	}

	public async LoadTransition(resourceManager: IReadOnlyResourceManager) {

		let transitionResources: ITransitionParams = null;
		if (Settings.PresentationType == Presentation.VideoGameSprite) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : null,
				//boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.Image) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + this.ScreenNumberConfiguration)),
				nameResource: null,
				fadeOut: true,
				particlesSprite : null,
				//boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
			transitionResources = {
				spriteResource: null,
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: null,
				nameResource: this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: false,
				particlesSprite : null,
				//boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : null,
				//boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
			
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
				boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
			
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add("FreegameClassic")),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("freegame")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
				boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else {
			throw `${Settings.PresentationType} its not implemented change your setting PresentationType`
		}

		transitionResources.bonusName = this.bonusName;
		
		this.transitionView = await this.systemContext.SharedTransitionContext().AddTransition(transitionResources);		
		//this.transitionView.ResourcesLoaded(resourceManager);		
		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}
		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
		//this.view.appendChild(this.transitionView.View());
	}
	

	

	protected BackgroundPrepare(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath +"background"+this.ScreenNumberConfiguration+"S/"+"background.png", this.resid.ScopedResourceName(["background", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void {
	
		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "fontStyle.ttf", this.resid.ScopedResourceName(["lines", "font"])));
	}

	protected gameBackground: string = null;
	protected async BaseLoaded(resourceManager: IReadOnlyResourceManager)
	{
		let gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
        this.gameBackground = gameBackground.CssBackground();

		this.backgroundFreeGameBonus.style.backgroundImage = this.gameBackground;		
		await this.LoadTransition(resourceManager);
	}

	// protected PicksPrepare(resourceManager: IWriteOnlyResourceManager): void 
	// {
	// 	resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick", this.resid.Add("pick"), true, this.logGroup.Add("pick"), true));
	// }

	//protected PicksPositions(): FreegamePickElemGeometry[] {
	//	let geometry: FreegamePickElemGeometry[] = [];
	//
	//	let displayWidth: number = 540 * 0.75;
	//	let displayHeight: number = 510 * 0.75;

	//	let displayRects: PixelRect[] = [
	//		new PixelRect(21, 328, displayWidth, displayHeight),
	//		new PixelRect(363, 528, displayWidth, displayHeight),
	//		new PixelRect(705, 328, displayWidth, displayHeight),
	//		new PixelRect(1044, 528, displayWidth, displayHeight),
	//		new PixelRect(1386, 328, displayWidth, displayHeight),
	//	];

	//	// offset relative to pick rect
	//	let pickRect = new PixelRect(50, 50, displayWidth - 100, displayHeight - 100);
	//	let awardRect = new PixelRect(50, 50, displayWidth - 100, displayHeight - 100);

	//	for (let i = 0; i < displayRects.length; i++) {
	//		geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	//	}

	//	return geometry;
	//}

	protected canvasSprite: CanvasSprite = null;
	
	// protected PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

	// 	let pickGeometries: FreegamePickElemGeometry[] = this.PicksPositions();
	// 	this.canvasSprite = null;

	// 	for (let i = 0; i < 5; i++) {

	// 		let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("pick")).sprite.Copy();
	// 		//let canvasSprite: CanvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	// 		this.canvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());

	// 		let params: FreegamePickElementParams = new FreegamePickElementParams(
	// 			i, 
	// 			this.logGroup,
	// 			pickGeometries[i].displayRect, 
	// 			pickGeometries[i].pickRect, 
	// 			pickGeometries[i].awardRect, 
	// 			this.canvasSprite
	// 		);

	// 		let pick: FreegamePickElement = this.params.pickElementFactory.CreatePickElement(params);

	// 		pick.AddPickCallback((index: number) => this.OnPicked(index));
	// 		pick.AddFreegamePickAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
	// 		pick.AddRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));

	// 		pick.OnDisplayAwardCallback = () => this.audio.Play(this.resid.ScopedResourceName("pick"));
	// 		pick.OnDisplayRemainingCallback = () => this.audio.Replay(this.resid.ScopedResourceName("remaining"));

			
	// 		this.picks.push(pick);
	// 		this.picksContainer.appendChild(pick.View());
			
	// 	}
	// }

	//History view
	protected PrepareHistory(resourceManager: IWriteOnlyResourceManager)
	{
		//resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/resources/playLines.css",this.resid.ScopedResourceName("playLines"), this.resid.Add("History").CSSScope()));
	}

	protected historySpinableReels = null;
	protected LoadedHistory(resourceManager: IReadOnlyResourceManager)
	{
		this.historySpinableReels =  new SpinnableReels(this.params.windowSymbolSize, new Rect(0,0,Scale.W(720),Scale.H(512)), this.params.spinnableReelsParams);
		SetStyles(this.historySpinableReels.GetView(),
		{
			position:"static"
		})
	}


	/**
	 *	BIG WIN
	 */
	protected BigWinPrepare(resourceManager: IWriteOnlyResourceManager): void {


		// message
		for (let i = 0; i < this.wins.length; i++) {
			resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/winmessages/" + this.wins[i].file, ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name), true, LogGroup.Global.Add("WinMsg").Add(this.wins[i].name), true));
		}

		// fountain
		resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/coin_1_200x200", ResourceIdentifier.Global.Add("fountain").Add("coin"), true, LogGroup.Global.Add("fountain").Add("coin"), true));
	}

	protected BigWinLoaded(resourceManager: IReadOnlyResourceManager): void {
		this.winMessageAnimation = new WinMessageAnimation(this.params.screenSize);
		this.shakeAnimation = new ShakeAnimation(this.spinnableReels.GetView());
		this.bigWinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(1920), Scale.H(250)), 150,this.resid.ScopedResourceName("bigwincount"));

		// messages
		for (let i = 0; i < this.wins.length; i++) {
			let message = new WinMessage(this.wins[i].name, resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name)).sprite.Copy(), this.wins[i].winMultiplier, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
			this.winMessageAnimation.AddMessage(message);
			message = null;
		}

		this.view.appendChild(this.winMessageAnimation.View());


		// fountain
		let fountainAnimation = SlotGameType1Shared.Instance().smallFountainAnimation;
		fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation = null;


		let countView = this.bigWinCountAnimation.View();
		countView.style.position = "absolute";
		countView.style.top = Scale.Ypx(500);
		//countView.style.left = this.params.windowRectangle.x + "px";
		countView.style.pointerEvents = "none";
		countView = null;

		this.view.appendChild(this.bigWinCountAnimation.View());
		resourceManager = null;
	}

	/**
	 *	FEATURES
	 *  TODO check what features are actually enabled in freegames!
	 */
	protected async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		// // EXPANDING WILD
		if (this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildBulk") ) {

			let params: ExpandingWildsBulkParam = {
				resid: this.resid,
				logGroup: this.logGroup,
				resourcesBasePath: this.basepath + "resources/expanding_wild_bulk/", 
				slotWindow: this.params.windowRectangle, 
				slotWindowSymbolSize: this.params.windowSymbolSize, 
				reelSetMapper: this.reelSetMapper, 
				audio: this.audio,
				gameName: this.gameName,
                availableSymbols: this.params.availableSymbols,
				systemContext: this.systemContext,
				symbolTypeAnim : this.params.gameConfig.symbolsType
            };
            
            let config: ExpandingWildsBulkConfig = this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildBulk")as unknown as ExpandingWildsBulkConfig;
			let expandingWildsBulk: ExpandingWildsBulk = new ExpandingWildsBulk(params, config);
			params = null;
			config = null;
			expandingWildsBulk.AddOnCompleteCallback(() => this.stateMachine.ChangeState(FreegameStates.BigWin));
			this.features.set("ExpandingWildBulk", expandingWildsBulk);
			expandingWildsBulk = null;
		}

		if (this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildReel") ) {
			let params: ExpandingWildsReelParam = {
				resid: this.resid,
				logGroup: this.logGroup,
				resourcesBasePath: this.params.gameResourcesBasePath + "resources/expanding_wild_reel/", 
				slotWindow: this.params.windowRectangle, 
				slotWindowSymbolSize: this.params.windowSymbolSize, 
				reelSetMapper: this.reelSetMapper, 
				audio: this.audio,
				gameName: this.gameName,
                availableSymbols: this.params.availableSymbols,
				systemContext: this.systemContext,
				symbolTypeAnim : this.params.gameConfig.symbolsType,
            };

            let config: ExpandingWildReelConfiguration = this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildReel") as ExpandingWildReelConfiguration;
		    let expandingWildsReel: ExpandingWildsReel = new ExpandingWildsReel(params, config);
		    expandingWildsReel.AddOnCompleteCallback(() => this.stateMachine.ChangeState(FreegameStates.BigWin));
		    this.features.set("ExpandingWildReel", expandingWildsReel);
			config = null;
			expandingWildsReel = null;
			params = null;
		}
		


		for (let [name, feature] of this.features)
		{
			await feature.PrepareResources(resourceManager)
		}
		
		await this.plusOneAnim.PrepareResources(resourceManager);

		if (this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ScatterRandomAward"))
		{
			let params: ScatterRandomAwardCreateParams =
			{
				logGroup: this.logGroup,
				resid: this.resid,
				// reelSet: this.params.bonusConfiguration.ReelSet,
				availableSymbols: this.params.availableSymbols
			};

			let config = {"ScatterRandomAward": this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration };

			this.scatterRandomAwardFeature = new ScatterRandomAwardPIXI(params, config, this.params.color);
			await this.scatterRandomAwardFeature?.PrepareResources(resourceManager);
			params = null;
			config = null;
			resourceManager = null;
		}


	}

	protected async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {


		// // EXPANDING WILD
		for (let [name, feature] of this.features)
		{
			await feature.ResourcesLoaded(resourceManager);
			this.reelsContainer.appendChild(feature.View());
		};

		await this.plusOneAnim.ResourcesLoaded(resourceManager);
		this.plusOneAnim.View().style.pointerEvents = "none"; // not clickable
		this.plusOneAnim.View().style.zIndex = ZIndex.PlusOne.toString();
		this.view.appendChild(this.plusOneAnim.View());

		await this.scatterRandomAwardFeature?.ResourcesLoaded(resourceManager);
		resourceManager = null;
	}

	/**
	 *	REELS
	 */
	public PrepareBackgroundReel(resourceManager: IWriteOnlyResourceManager)
	{
		this.spinnableReelsParams.backgroundImage=new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reel.png", this.resid.ScopedResourceName(["reel","image"]));
		resourceManager.Add(this.spinnableReelsParams.backgroundImage);

		this.spinnableReelsParams.maskbackgroundImage = new DecodedImageResource(this.basepath + "resources/reelMask.png", this.resid.ScopedResourceName(["reelMask", "image"]));
		resourceManager.Add(this.spinnableReelsParams.maskbackgroundImage);		
	}

	protected handleLoadProgeres(loader, resource) {
		console.log(loader.progress + "% -FreeGameBonus-loaded");
	}
	
	// protected colorLineMarkers: MarkersInfoColors =
	// {
	// 	MarkerbackgroundColor: "linear-gradient(90deg, rgba(6,65,42,1) 0%, rgba(117,255,9,1) 35%, rgba(183,255,9,1) 55%, rgba(117,255,9,1) 75%, rgba(6,65,42,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
	// 	//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
	// };

	protected async PrepareWinLines(resourceManager: IWriteOnlyResourceManager)
	{
		// construct win lines
		let winLinesAnimParams: WinLinesAnimationParams =
		{
			viewSize: this.params.screenSize,
			spinnableReels: this.spinnableReels,
			lines: this.params.playlines,
			logGroup: this.logGroup,
			resid: this.resid,
			systemContext: this.systemContext,
			slotWindow : this.params.windowRectangle,
			slotWindowSymbolSize :this.spinnableReels.GetWindowSymbolSize(),
			colorLineMarkers : this.params.colorLineMarkers,
			speedFactorAnimation: this.params.winAnimationSpeedFactor,
			gameName : this.gameName,
			winLinesTypeStyle : this.params.gameConfig.winLinesTypeStyle,
		};

		// TODO replace with factory
		this.winLinesAnimation = new WinSquareAnimations(winLinesAnimParams);


		this.winLineMarkers = new WinLineMarkers(this.params.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.params.playlines);

		this.winLinesAnimation.AddStartLineCallback((line: LineWin, color: Color) => 
		{
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("linecount"));
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("lineCountBackground"));
		});

		this.winLinesAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => 
		{
			this.winLineMarkers.Show(line.LineIndex, color);
			this.panel.SetMessage(this.translator.t.linepay("" + (line.LineIndex +1), service.moneyFormatter.FormatCreditCurrentDenom(line.Win)));
			let symbolPositions:SymbolPositionToAnimate[] = [];
			let lineindex:number = line.LineIndex;

			let symbolsToAnimate: number = this.params.playlines[lineindex].length;
			if (animateOnlyWinningSymbols)
			{
				symbolsToAnimate = line.SymbolCount;
			}

			for(let i = 0; i < symbolsToAnimate; i++)
			{
				symbolPositions.push(new SymbolPositionToAnimate(i,this.params.windowSymbolSize.Height - 1 - this.params.playlines[lineindex][i]));
			}
			
			this.screenProtocol?.Send(new SlotGameMessages.WiningSymbol(line.SymbolIndex), this.screenProtocolScope);			
			this.symbolsAnimation.Stop();
			try {
				this.spinnableReels.StopSymbolsAnim();
				this.spinnableReels.PlaySymbolsAnim(symbolPositions);
				

			} catch (error) {
				Log.Error(this.logGroup, "Error playanim symbol", error);
			}
			
			symbolPositions = null;
			symbolsToAnimate = null;
			lineindex = null;
		});

		this.winLinesAnimation.AddCompleteCallbacks(() => 
		{
			try {
				this.spinnableReels.StopSymbolsAnim();	
			} catch (error) {
				Log.Error(this.logGroup, "Error stopsanim symbol", error);
			}			
			this.winLineMarkers.Hide();		
			this.audio.Stop(this.parentresid.ScopedResourceName("linecount"));
			this.audio.Stop(this.parentresid.ScopedResourceName("lineCountBackground"));
			
			this.stateMachine.ChangeState(FreegameStates.Collect); 
			//this.DisableSymbolsAnimation();
			
		});

		await this.winLinesAnimation.PrepareResources(resourceManager);
		winLinesAnimParams = null;
		resourceManager = null;
		
	}


	protected anticipationStarted: boolean = false;
	private ConstructReels(resourceManager: IWriteOnlyResourceManager): void {

		this.spinnableReels = new SpinnableReelsBigCanvas(this.params.windowSymbolSize, this.params.windowRectangle, this.params.spinnableReelsParams , this.resid, this.systemContext);
		let spinnableReelsView: HTMLElement = this.spinnableReels.GetView();
	
		this.spinAnimation = new SpinAnimation(this.logGroup);
		this.reelSetMapper = new ReelSetMapper(this.params.windowSymbolSize, this.logGroup);

		//this.InitializeIsAnimation();

		spinnableReelsView = null;
	}

	protected reelElement:  PIXI.Container[] = null;
	protected reelMask:  PIXI.Container[] = null;
	protected reelSpinAnimation : ReelSpinAnimation [] = [];

	protected LoadedReels(){

		for (let i: number = 0; i < this.spinnableReels.GetWindowSymbolSize().Width; i++) {
			((i: number) => {

				
				let isSpinEnding = false;				
				//console.log("reelElementReturned:",	this.reelElement[i]);				
				//console.log("reelElementReturned:",reelWhitBackgroundElement[i]);				
				//SetStyles(reelWindowElement., {margin: "0px 5px"});

				// const anticipationZoomFactor: number = 1.125;
				// const idleZIndex: number = ZIndex.ReelContainerBackground;
				// const anticipationZIndex: number = 100;


				//const anticipationBeginAnim = TweenLite.to(reelWhitBackgroundElement[i], 0.5, {pixi:{scaleY: anticipationZoomFactor, onStart: () =>this.reelElement[i].zIndex = anticipationZIndex}});
				//const anticipationEndAnim = TweenLite.to(reelWhitBackgroundElement[i], 0.5, {pixi:{scaleY: 1,onStart: () =>this.reelElement[i].zIndex = idleZIndex}});

				//let originalBackgroundAnticipation: Color = null;
				//let newBackgroundAnticipation: Color = null;

				let r: ReelSpinAnimation = new ReelSpinAnimation(
					i,
					this.logGroup,
					this.spinnableReels.GetSymbolSize(),
					this.spinnableReels.GetWindowSize(),
					this.spinnableReels.GetWindowSymbolSize(),
					this.spinnableReels.GetExtendendWindowSymbolSize(),
					this.params.reelAnimationParams.SpeedFactor,
					this.params.reelAnimationParams.Duration,
					this.params.reelAnimationParams.Delay,
					this.params.reelAnimationParams.SpeedCorrection

				);

				this.reelSpinAnimation.push(r)

				let m: ReelMapper = new ReelMapper(i, this.logGroup, this.params.windowSymbolSize.Height, this.spinnableReels.GetExtendendWindowSymbolSize().Height);

				this.reelSetMapper.AddReelMapper(m);

				r.AddOnStartCallback(() => {
					isSpinEnding = false;
					m.Start();					
					this.DisableReelOverflow(i);					
					//this.bigSymbolAnim.UpdateSymbols(i, m.GetSymbols2().map(s => s.symbolIndex));
				});
 
				r.AddOnStopAvailableCallback((reelIndex) => {
					//// Log.Debug(this.logGroup, "Reel stop request is available");
				});

				r.OnUpdateCallback = (anim, params) => {

					//let roundToNPlaces: number = 3;
					// let distance = Math.round(r.GetDistance() * 1000)
					// let symbolHeight = Math.round(this.spinnableReels.GetSymbolSize().height * 1000);

					// let distanceInSymbols = Math.floor(distance / symbolHeight);
					// let translate = (distance % symbolHeight) / 1000;

					//// Log.Debug(this.logGroup, "Reel " + i + " symbol height: " + this.spinnableReels.GetSymbolSize().height + ", distance " + distance + ", in symbols, " + distanceInSymbols + ", translate y: " + translate);

					m.Update(params.distanceSymbols);

					// symbols in window have changed, update
					if (m.DidSymbolsChange()) 
					{
						this.RedrawReel(i);

						if (isSpinEnding)
						{
							//this.bigSymbolAnim.UpdateSymbols(i, newSymbols);
						}
					}

					if (this.reelElement?.[i]?.transform?.position)
                    {
                        this.reelElement[i].transform.position.y = params.translatePixels;
                    }
				};

				r.onAnticipationBeginCallbacks = () => {
					// Log.Debug(this.logGroup, "Anticipation begin");

					//anticipationBeginAnim.restart();

					if (!this.anticipationStarted) {
						//console.log(`Anticipation started reel ${i}`);
						this.anticipationStarted = true;
						this.audio.Play(this.resid.ScopedResourceName("anticipation"));
					}
				};

				r.onAnticipationEndCallbacks = () => {
					// Log.Debug(this.logGroup, "Anticipation end");

					//anticipationBeginAnim.pause();
					//anticipationEndAnim.restart();
				};

				r.AddOnDeccelerationCallbak((params: OnDeccelerationParams) => {
					// Log.Debug(this.logGroup, "decceleration started");

					// when decceleraton starts, we know when animation will end, so we can set up reel slice distance

					//let distance = r.GetDistance() + params.distanceToEnd;
					let distanceInSymbols = params.totalDistanceInSymbols; //Math.floor( / 100);

					m.Slice(distanceInSymbols);
					isSpinEnding = true;
					distanceInSymbols = null;
				});

                r.onNearComplete = this.OnReelNearStopped.bind(this);			

				this.spinAnimation.AddReelAnimation(r);
			})(i);
		}
		
		//Here
		this.spinAnimation.AddOnStartCallback(() => {
			//this.bigSymbolAnim.Stop();
		});

		this.spinAnimation.AddOnCompleteCallback(() => this.SpinComplete());
		this.spinAnimation.AddOnCompleteCallback(() => {
			this.anticipationStarted = false;
			this.audio.Stop(this.parentresid.ScopedResourceName("anticipation"));
		});


		this.reelSetMapper.SetReelSet(this.params.bonusConfiguration.ReelSet, this.params.startPositions);
		this.currentSymbols = this.reelSetMapper.GetSymbols2();
		if (Settings.touchToStop == true) {
			let spinnableReelsView: HTMLElement = this.spinnableReels.GetView();	
			AddMouseDownListener(spinnableReelsView, () => {
				this.spinAnimation.RequestStop();
			});
		}

		// redraw reels when context recovers
		this.spinnableReels.OnCreatedCallback = () => this.ReelsRestored();

		// redraw reels right away
		this.ReelsRestored();
	}

	protected DisableReelOverflow(reelIndex: number) {
		try {
			//show top symbols		
			this.spinnableReels.symbolPIXISprite[reelIndex][this.spinnableReels.symbolPIXISprite[reelIndex].length - 1].visible = true;
		} catch (error) {
			Log.Error(this.logGroup, "Error disable overflow reel", error);
		}
	}

    protected RedrawReel(reelIndex: number): void
	{
		// 2 symbols more than window height 
		//	 - scrolling reveals additional symbol on top
		//	 - we don't want to change top symbol right at the top window line, 
		//     in case the top symbols peeks out a little
		this.currentSymbols[reelIndex] = this.reelSetMapper.GetReelMapper(reelIndex).GetSymbols2();

		for (let rowIndex: number = 0; rowIndex < this.currentSymbols[reelIndex].length; rowIndex++) {
			this.DrawSymbol(reelIndex, rowIndex);
		}
	}

	protected currentSymbols: ReelSymbolsToDisplay[][] = [];
	//protected EnableCache : Boolean = true;
	public DrawSymbol(reelIndex: number, rowIndex: number): void {
		try 
        {
			let canvasPIXI: PIXI.AnimatedSprite = this.spinnableReels.symbolPIXISprite?.[reelIndex]?.[rowIndex];
			if (!canvasPIXI)
			{
				// no canvas to draw
				return;
			}

			let symbolToDisplay: ReelSymbolsToDisplay = this.currentSymbols[reelIndex][rowIndex];
			let symbol: SlotSymbol = this.params.availableSymbols[symbolToDisplay.symbolIndex];
			//canvas.renderable = true;
			canvasPIXI.textures = this.params.pixiSpritesByName.get("Symbol_" + symbol.ID);
			this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI);
			canvasPIXI = null;
			reelIndex = null;
			rowIndex = null;
		}
		catch (ex) {
			//Log.Error(this.logGroup, "Error drawing symbol", ex);
		}
	}

//protected isSymbolAnimation : boolean [][] = [];
	//init symbol array animation
	// protected InitializeIsAnimation() {
	// 	for (let reel = 0; reel < this.spinnableReels.GetWindowSize().width; reel++) {
	// 		this.isSymbolAnimation.push([]);
	// 		for (let row = 0; row < this.spinnableReels.GetWindowSize().height; row++) {
	// 			this.isSymbolAnimation[reel][row] = false;
	// 		}			
	// 	}
	// 	//console.log("ArraySymbolsAnim:",this.isSymbolAnimation);
	// }

	// protected EnableSymbolsAnimation(positions: SymbolPositionToAnimate[]): void {
	// 	//console.log("ArraySymbolsAnimPositions:",positions);
	// 	//disable all symbols anim 
	// 	this.DisableSymbolsAnimation();
	// 	//only enable whe need anim 
	// 	for (let p of positions) {
	// 		this.isSymbolAnimation[p.reel][p.row] = true;
	// 		p = null;
	// 		//console.log("ArraySymbolsAnimPositions reel:",p.reel , "row:",p.row);
	// 	}
	// }

	//disable symbols anim 
	// protected DisableSymbolsAnimation(): void {
	// 	for (let reel = 0; reel < this.isSymbolAnimation.length; reel++) {
	// 		for (let row = 0; row < this.isSymbolAnimation[reel].length; row++) {
	// 			this.isSymbolAnimation[reel][row] = false; 
	// 		}
	// 	}
	// 	//console.log("ArraySymbolsAnim:",this.isSymbolAnimation);
	// }


	protected popoutAnimations: TweenLite[] = [];
	protected lastReelStoppedTime: number = 0;
	protected OnReelNearStopped(reelIndex: number) {
		if (Timing.Timeouted(this.lastReelStoppedTime, 20)) {
			this.lastReelStoppedTime = Timing.Now();
			this.audio.Play(this.resid.ScopedResourceName("reelstop"), true);
		}		
	}


	public Confirm():void
	{
		
		if (this.stateMachine.State() == FreegameStates.NoPickIntro) {
			// Log.Debug(this.logGroup, "Intro message confirmed");
			this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
		}
		else if (this.stateMachine.State() == FreegameStates.IntroMessage) {
			// Log.Debug(this.logGroup, "Intro message confirmed");
			this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
		}
		// else if (this.stateMachine.State() == FreegameStates.PickedMessage) {
		// 	// Log.Debug(this.logGroup, "Intro message confirmed");
		// 	this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
		// }
		else if (this.stateMachine.State() == (FreegameStates.FinalMessage)) {
			// Log.Debug(this.logGroup, "Final message confirmed");						
			this.ShowVideoTransition();	
		}
		else
		{
			Log.Error(this.logGroup, "Can't confirm message, current state: " + FreegameStates[this.stateMachine.State()]);
		}

	}
	public Spin(): void {

		// Log.Debug(this.logGroup, "Spin");

		switch (this.stateMachine.State()) {
			//case FreegameStates.Running:

			// when in idle state, spin starts new spin
			case FreegameStates.SpinIdle:
			case FreegameStates.WaitFirstSpin:
				
				// make sure to clear timer, to prevent double spin??
				if (this.session.left > 0) {

					// Log.Debug(this.logGroup, "Spin: Requesting next spin");

					if (this.autoSpinTimer != null) clearTimeout(this.autoSpinTimer);
					this.spinInterrupted = false;

					this.spinAnimation.Start();
					//debugger;
					
					// protocol.Send("BonusNextRun", null);
					this.stateMachine.ChangeState(FreegameStates.Spin);
			 	}
			break;
			// case FreegameStates.PickedMessage:
			case FreegameStates.FinalMessage:
			case FreegameStates.IntroMessage:			
				// Log.Debug(this.logGroup, "Spin: Confirming message");
				this.Confirm();
				break;
			case FreegameStates.NoPickIntro:
			 	// Log.Debug(this.logGroup, "Spin: Confirming message");
			 	this.Confirm();
				break;

			case FreegameStates.Spin:
				// Log.Debug(this.logGroup, "Spin: Request spin stop");
				this.spinAnimation.RequestStop(-1);
			break;

			case FreegameStates.Features:
				// Log.Debug(this.logGroup, "Spin: Request features stop");
				if(this.stateMachine.TimeSinceLastStateChange() > 1000){
					this.RequestFeatureStop();
				}				
			break;

			// When in win state, spin interrupts the count
			case FreegameStates.Win:
				// Log.Debug(this.logGroup, "Spin: Request win stop");
				this.spinInterrupted = true;
				this.winLinesAnimation.RequestStop();
			break;

			default:
				// Log.Debug(this.logGroup, "Spin: Nothing to do in current state: " + this.stateMachine.StateName);
			break;
		}
	}

	public AutoSpin(): void {
		// Log.Debug(this.logGroup, "Autospin");
		this.Spin();
	}

	// TODO change, remove, improve
	public Reset(): void {
		this.lastSpinResult = null;
	}

	private SpinComplete(): void {
		this.stateMachine.ChangeState(FreegameStates.Features);
	}

	public Start(): void {
		// Log.Debug(this.logGroup, "Bonus started");

		this.lastSpinResult = null;
		this.session.Reset();

		{
			this.session.awarded = this.simpleBonusConfig.SpinsStarted;
			this.session.left = this.simpleBonusConfig.SpinsStarted;
			this.session.played = 0;

			this.stateMachine.ChangeState(FreegameStates.IntroTransition);
		}

		this.Show();

		this.PanelRequired(true);

		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
	}


	public Show()
	{
		this.view.style.display = "block";
		this.PanelRequired(true);
		//console.log("Show free game");
	}

	public Hide()
	{
		this.view.style.display = "none";
		//console.log("Hide free game");
	}


	protected forceSymbolsUpdate: boolean = false;
	public Update(): void {
		
		this.spinAnimation.Update();
		//this.transition.Update();

		this.features.forEach((feature) => feature.Update());

		this.symbolsAnimation.Update();
		this.winMessageAnimation.Update();
		this.shakeAnimation.Update();
		this.winLinesAnimation.Update();
		this.plusOneAnim.Update();

		//Update for transition sprite ;
		this.transitionView.Update();
		this.RedrawCanvas();		
		this.fillingPotFeature?.Update();
		this.spinnableReels.Update();
	}

	
	public RedrawCanvas(){
		if (this.buttonStartCanvas.WasContextLost() ) {
			this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);			
		}
		if (this.buttonExitCanvas.WasContextLost() ) {
			this.SetTextCanvas(this.translator.t.freegameStart, this.buttonExitCanvas);			
		}
	}

	public View(): HTMLElement {
		return this.view;
	}

	public GetSession(): GameSession {
		return this.session;
	}

	/**
	 *	Internal states
	**/
	private HideAllContainers(): void {
		this.containers.forEach((container, key) => container.style.display = "none");
	}

	private ShowContainer(container: FreegameBonusContainer): void {
		// Log.Debug(this.logGroup, "Showing container " + FreegameBonusContainer[container]);

		let htmlElement = this.containers.get(container);
		if (htmlElement != null)
		{
			htmlElement.style.display = "block";
		}
		else
		{
			Log.Error(this.logGroup, "Container does not exist: " + FreegameBonusContainer[container]);
		}
	}

	protected started:boolean=false;
	public ShowVideoTransition(): void{
		if(this.started == false){
			this.transitionView.ShowTransiton();
			//this.systemContext.SharedTransitionContext().GetTransition(this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration))
			this.started = true;
		}		
	}

	protected OnTransitionStarted(){	
		// play transition audio
		this.audio.Play(this.resid.ScopedResourceName("transitionaudio"));	
		this.started = true;	
	}

	protected OnTransitionEnded(): void {
		// Log.Debug(this.logGroup, "Transition ended");
		this.started = false;
		if (this.stateMachine.State() == FreegameStates.FinalMessage) {
			this.stateMachine.ChangeState(FreegameStates.Idle);
		} else {
			this.stateMachine.ChangeState(FreegameStates.NoPickIntro);
		}
	}

	protected OnIntroTransitionBegin(): void
    {	
	this.OnNoPickIntroMessageBegin()
    }

    protected OnIntroTransitionEnd(): void
    {
		//this.OnTransitionEnded();
    }

	private OnIntroMessageBegin(): void {
		this.HideAllContainers();		
		this.ShowContainer(FreegameBonusContainer.IntroMessage);
		this.robotPlay.BonusConfirm("IntroMessage");
	}

	private OnIntroMessageEnd(): void {		
		this.robotPlay.BonusConfirmAccepted();
	}

	
	//protected triggerStartSoundLoop: ITimeout;
	//protected introStartSound: ITimeout;
	public override TriggerAnimationStartedSprite(loop : number): void {		
		let delay: number = 1000;
		for (let i = 0; i < loop; i++) {
			setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("triggered")), delay * (i + 1));
		}
	}

	
	public override BackGroundTransition(): void {		
		this.audio.Play(this.resid.ScopedResourceName("intro"));				
	}

	public OnNoPickIntroMessageBegin():void
	{
		this.HideAllContainers();
		//this.noPickintroMessageContainer.querySelector(".numPickedFreegames").innerHTML = "" + this.session.awarded;
		this.ShowContainer(FreegameBonusContainer.Reels);
		this.ShowContainer(FreegameBonusContainer.NoPickIntro);
		this.screenProtocol?.Send(new FreegameMessages.PickMessage(this.session), this.screenProtocolScope);
		this.robotPlay.BonusConfirm("PickedMessage");
	}

	private OnNoPickedMessageEnd(): void {
		this.HideAllContainers();
		this.ShowContainer(FreegameBonusContainer.Reels);
		this.robotPlay.BonusConfirmAccepted();
	}
	
	
	private OnWaitFirstSpinBegin(): void {
		this.PanelRequired(true);
		this.timeoutAutoSpinFreeGames.Start();
	}
	//change type because need add some feature for 1 screen game 
	protected OnSpinBegin(): void {
		this.session.left--;
		this.session.played++;
		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));
		this.screenProtocol?.Send(new FreegameMessages.SpinMessage(this.session), this.screenProtocolScope);
		this.OnBonusRunResult();		
	}

	private OnSpinEnd(): void {
		this.audio.Stop(this.parentresid.ScopedResourceName("leverpull"));
	}

	protected featuresTimer: number = -1;
	protected currentFeature: SlotFeature = null;	
	protected currentBonus: SlotBonus = null;
	
	protected OnFeaturesBegin() {
		let timeout = 0;		
		if (Settings.fillingPotFeature != FillingPotFeature.Disable) {
			let ScatterRandomAward = (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)
			if (ScatterRandomAward?.ScattersPositionThisSpin.length > 0) {
				timeout += 500;
			}
			this.fillingPotUpdate?.Start();
		}			

		if (this.currentBonus != null)
		{
			// Log.Debug(this.logGroup, "Symbol trigger feature");
			this.panel.SetMessage(this.translator.t.message_bonustriggered);
			try {
				this.spinnableReels.StopSymbolsAnim();
				this.spinnableReels.PlaySymbolsAnim(this.bonusTriggerSymbols);				
				this.currentBonus.TriggerAnimationStartedSprite(1 , 0);
			} catch (error) {
				Log.Error(this.logGroup, "Error play symbol", error);
			}

			timeout += 4000;
			
			this.timeoutStopsAnim.Start();		
		}
		
		// prepare current feature
		this.currentFeature = null;
		//let delay: number = timeout;
		if (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"]?.FeatureTriggered && this.simpleLastBonusAction.Win.ResultLines.length > 0){
			this.currentFeature = this.features.get("ExpandingWildBulk");
			this.currentFeature.Prepare(this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"])
		}
		else if (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]?.FeatureTriggered && this.simpleLastBonusAction.Win.ResultLines.length > 0){			
				this.currentFeature = this.features.get("ExpandingWildReel");
				this.currentFeature.Prepare(this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]);
		}		

		if (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["PlusOneFeature"] && this.plusOneAnim.WillStartAnim() == true) {
			this.audio.Play(this.resid.ScopedResourceName("plusone"));
			let plusone = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["PlusOneFeature"] as unknown as PlusOneFeatureResult
			this.plusOneAnim.Start(plusone.SymbolPositions, this.plusOneTarget);			

			setTimeout(() => {
				this.audio.Play(this.resid.ScopedResourceName("plusonemove"))}, 1000);
				
			timeout += this.plusOneAnim.Duration();
			
			// refresh top screen
			setTimeout(() => {
					this.screenProtocol?.Send(new FreegameMessages.PlusMessage(this.session), this.screenProtocolScope)
					this.ApplySession(this.session)
					
				}, timeout);

			timeout += 1500;
			plusone = null;
		}

		// start feature with delay, or continue to next state
		this.featuresTimer = window.setTimeout(() => {			
				if (this.currentFeature != null)
				{
					this.currentFeature.Start();
					this.robotPlay.OnSpinStopAvailable();
				}
				else
				{
					// no "known" features, continue to next state
					
					
					
					// this.stateMachine.ChangeState(FreegameStates.BigWin);
				}
			this.featuresTimer = -1;
			//this.stateMachine.ChangeState(SlotGameState.Scatter);
		}, timeout);
		
		//this.stateMachine.ChangeState(SlotGameState.BigWin);
	}

	//Create For Update The Session For 1 Screen Game
	protected ApplySession( session:FreegameSession): void
	{
		//TODO
	}

	protected RequestFeatureStop(): void
	{
		if (this.currentFeature != null)
		{
			this.currentFeature.RequestStop();
			this.symbolsAnimation.Stop()
			this.symbolsAnimation.Update();
			
		}
	}

	protected OnFeaturesEnd(): void
	{
		this.currentFeature = null;
	}

	private OnBigWinBegin(): void {

		let winCredit: number = service.moneyFormatter.CentsToCredit(this.simpleLastBonusAction.Win.TotalWin);

		if (this.winMessageAnimation.WillTrigger(this.bet, winCredit)) {
			winCredit = null;
			this.shakeAnimation.Start();
			this.audio.Play(this.parentresid.ScopedResourceName("bigwin"));
			this.timeoutFreeGameWin.Start();
		}
		else {
			// Log.Debug(this.logGroup, "Big win message will not show");
			this.stateMachine.ChangeState(FreegameStates.Win);
		}
	}

	private OnBigWinEnd(): void {
		let winCredit: number = service.moneyFormatter.CentsToCredit(this.simpleLastBonusAction.Win.TotalWin);

		if (this.winMessageAnimation.WillTrigger(this.bet, winCredit)) {
			this.winMessageAnimation.Start(this.bet, winCredit);
			this.fillingPotFeature?.OnStartBigWinShow();
			winCredit = null;
			this.bigWinCountAnimation.View().style.visibility = "visible";
			SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
		}
	}

	private OnWinBegin(): void {		
		if (this.simpleLastBonusAction.Win.TotalWin.InCents > 0)
		{

			let fixedDuration: number;
			fixedDuration = this.winLinesAnimFactor / this.simpleLastBonusAction.Win.ResultLines.length;


			let duration:number = 0;
			if(this.simpleLastBonusAction.Win.ResultLines.length <= 10)
			{
				duration = this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 3 * 1000;
				if(duration == 0 ){
					//console.log("LineCount <= 10");
					duration = this.winLinesAnimFactor * 3 //* 1000;
				}
			}

			else if(this.simpleLastBonusAction.Win.ResultLines.length >= 11 && this.simpleLastBonusAction.Win.ResultLines.length <= 50)
			{
				duration = this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 2 * 1000;
				if(duration == 0 ){
					//console.log("LineCount >= 11 && LineCount <= 50");
					duration = this.winLinesAnimFactor * 2 //* 1000;
				}
			}
			else if(this.simpleLastBonusAction.Win.ResultLines.length >= 51)
			{
				duration = this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 1 * 1000;
				if(duration == 0 ){
					//console.log("LineCount >= 51");
					duration =  this.winLinesAnimFactor * 3 //* 1000;
				}
			}
			this.winLinesAnimation.Start(this.simpleLastBonusAction.Win.ResultLines, duration*this.simpleLastBonusAction.Win.ResultLines.length);
			duration = null;			
			this.session.totalWin = this.simpleLastBonusAction.WinSinceGameStart.TotalWin.InCents;
			this.session.winDuration = this.winLinesAnimation.GetDuration()/1000;
			this.screenProtocol?.Send(new FreegameMessages.WinMessage(this.session),this.screenProtocolScope);			
			this.winCreditAnimation = TweenMax.fromTo(this.winValues,
			this.winLinesAnimation.GetDuration()/1000,
			{win:this.params.clientState.PreviousWin},
			{win:this.params.clientState.Win, roundProps:"balance,win", 
				onUpdate: ()=>
				{
					this.bigWinCountAnimation.Display(service.moneyFormatter.CentsToCredit(this.winValues.win));
					this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.winValues.win ), service.moneyFormatter.FormatCurrency(this.winValues.win));
					
					//this.panel.SetBalance(this.moneyFormatter.FormatCredit(this.winValues.balance), this.moneyFormatter.FormatCurrency(this.winValues.balance));
				},
				onComplete:()=>{
					//this.EnableCache = true;
				}
			});

			this.robotPlay.BonusRunStopAvailable();
		}
		else 	
		{
			this.stateMachine.ChangeState(FreegameStates.Collect);
			
		}
	}

	private OnWinEnd(): void {
		// fast forward win count, if needed
		if (this.winCreditAnimation != null && this.winCreditAnimation.progress() != 1) {
			this.winCreditAnimation.progress(1, false);
		}

		this.symbolsAnimation.Stop();		
		this.winMessageAnimation.Stop();
		this.fillingPotFeature?.OnEndBigWinShow();
		SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
		this.bigWinCountAnimation.View().style.visibility = "hidden";		
	}

	private OnCollectBegin(): void {

		this.stateMachine.ChangeState(FreegameStates.Bonus);
		this.screenProtocol?.Send(new FreegameMessages.WinInterruptedMessage(), this.screenProtocolScope);
		this.panel.SetMessage(this.translator.t.goodluck);
	}

	protected nextBonusData: ISimpleBonusAction[] = [];
	private OnBonusBegin(): void {
		let currentindexData = this.simpleAllBonusSpinResult.findIndex((b) => b == this.simpleLastBonusAction);
		this.nextBonusData = this.simpleAllBonusSpinResult.filter((b, index) => index > currentindexData);


		//reste Bonus level if you hit some bonus 
		let bonusStartData = this.nextBonusData.find(b => b.Phase == "Start");
		//let bonusStartData = nextBonusData.find((b, index) => index == indexStartConfig);
		if (bonusStartData == this.simpleAllBonusSpinResult[currentindexData + 1]) {
			let bonusName = bonusStartData.Bonus as Bonus;
			if (bonusName) this.fillingPotFeature?.StartBonusWin(bonusName);
		}

		bonusStartData = null;

		if (this.nextBonusData[0].Phase == "Start") {
				currentindexData = null;			
			this.timeoutShowBonusIntoBonus.Start();
		}
		else {
			this.stateMachine.ChangeState(FreegameStates.SpinIdle);
		}
	}

	public NextBonusEnd()
	{
		if(this.currentBonus != null)
		{
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.params.clientState.Win), service.moneyFormatter.FormatCurrency(this.params.clientState.Win));
			this.stateMachine.ChangeState(FreegameStates.SpinIdle);
		}
		else
		{
			Log.Error(this.logGroup, "no next bonus");
		}
	}

	private OnBonusEnd(): void {
		if (this.currentBonus) {
			this.currentBonus = null;
			this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		}
		this.fillingPotFeature?.RestartAnim();		
	}

	private OnSpinIdleBegin(): void {

		this.panel.SetMessage("");

		//this.freegamesLeft.innerHTML = "Free games Left "+ this.session.left;
		//this.freegamesPlayed.innerHTML ="Free games Played "+ this.session.played;
		

		if (this.session.left > 0) {
			this.lastSpinResult = null;			
			this.simpleBonusConfig = null;
			// put some delay before next spin
			if (this.spinInterrupted) {
				this.AutoSpin();
			}
			else {
				this.panel.Start();
				
				this.autoSpinTimer = window.setTimeout(() => this.AutoSpin(), 500);
				//this.autoSpinTimer.Start();
			}
		}
		else {
			this.CreateTransitionPixi();
			// put some delay before final message			
			this.timeoutFreeGameFinalMessage.Start();
		}
	}

	private OnSpinIdleEnd(): void {
		this.panel.Stop();
	}

	private OnFinalMessageBegin(): void {	
		
		this.audio.PlayLoop(this.resid.ScopedResourceName("final"));
		this.audio.Stop(this.resid.ScopedResourceName("background"));






		this.PanelRequired(true);

		//this.HideAllContainers();

        // FIXME no query selector
		//this.finalMessageContainer.querySelector(".bonusCredits").innerHTML = this.moneyFormatter.FormatCreditCurrentDenom(this.lastSpinResult.TotalWin)

		this.ShowContainer(FreegameBonusContainer.FinalMessage);
		//this.transition.Start();
		this.VoicePlay=true;
		//SHOW VIDEO TRANSITION
		//this.ShowVideoTransition();

	

		
		this.robotPlay.BonusConfirm("FinalMessage");
		let spinEndAction = this.simpleAllBonusSpinResult.find(b=>b.Phase == "End" && b.Bonus == this.bonusName);
		this.session.totalWin = spinEndAction.WinSinceGameStart.TotalWin.InCents;
		spinEndAction = null;
		this.screenProtocol?.Send(new FreegameMessages.ShowWinContainer(this.session), this.screenProtocolScope);
	}

	private OnFinalMessageEnd(): void {
		//this.ShowVideoTransition();
		this.screenProtocol?.Send(new FreegameMessages.ResetFinalContainerWin(this.session), this.screenProtocolScope);		
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.Stop(this.resid.ScopedResourceName("final"));
		this.audio.Play(this.resid.ScopedResourceName("backgroundend"));
		this.OnBonusFinished();
		//this.transition.Start();
		this.robotPlay.BonusConfirmAccepted();
		this.VoicePlay=true;		
	}

	/**
	 *	External messages
	**/

	protected bonusTriggerSymbols: SymbolPositionToAnimate[] = [];
	public spinIndexData: number = 0;
	protected simpleLastBonusAction : FreegamesSpinAction;
	protected simpleAllBonusSpinResult: ISimpleBonusAction [] = null;
	public OnBonusRunResult(): void {

		//// Log.Debug(this.logGroup, "OnBonusRunResult(runResult: " + JSON.stringify(runResult) + ")");

		this.fillingPotFeature?.UpdateSpin();
		
		this.spinIndexData++;
		this.simpleLastBonusAction = this.simpleBonusSpin[this.spinIndexData];
		//this.lastSpinResult = fgRunResult;

		this.session.left= this.simpleLastBonusAction.SpinsRemaining;
		this.session.played = this.simpleLastBonusAction.SpinsPlayed;


		
		//update clienStat win the last win 
		this.params.clientState.SetWin(this.simpleLastBonusAction.WinSinceGameStart.TotalWin.InCents, "BigSymbolFreegames run result");
		
		

		//this.freegamesLeft.innerHTML = "Free games Left "+ this.session.left;
		//this.freegamesPlayed.innerHTML ="Free games Played "+ this.session.played;

		let targets: SpinTargetParams[] = [];
		for (let i = 0; i <this.simpleLastBonusAction.SpinWithFeatures.ReelStops.length; i++) {
			// anticipation can't be on the first reel
            let t: SpinTargetParams = {
                position: this.simpleLastBonusAction.SpinWithFeatures.ReelStops[i],
                anticipation: this.simpleLastBonusAction.Anticipation >= 0 && i >= this.simpleLastBonusAction.Anticipation,
                firstAnticipationReelIndex: this.simpleLastBonusAction.Anticipation,
            };
			targets.push(t);
			t = null;
		}
		
				this.bonusTriggerSymbols = [];
				if(this.simpleLastBonusAction.Triggers != null)
				{
					Object.entries(this.simpleLastBonusAction.Triggers);
					for(let [name,triggerResult] of Object.entries(this.simpleLastBonusAction.Triggers))
					{
						if((triggerResult as SimpleTriggerResult).symbolsTriggered != null)
						{
							let symbolsTriggered:SymbolPosition [] = (triggerResult as SimpleTriggerResult).symbolsTriggered;
							for(let i = 0; i < symbolsTriggered.length; i++)
							{
								this.bonusTriggerSymbols.push(new SymbolPositionToAnimate(
									symbolsTriggered[i].Reel,
									this.params.windowSymbolSize.Height - symbolsTriggered[i].Row -1
								));
							}
						}
						
					} 
				}
		

		// if(fgRunResult.Bonus != null)
		// {
		// 	this.currentBonus = this.bonusList.get(fgRunResult.Bonus);
		// }

		/* for (let i = 0 ; i < fgRunResult.ReelStops.length; i++)
		{
			targets.push(new SpinTargetParams(fgRunResult.ReelStops[i], false));
		} */

		this.spinAnimation.SetTargets(targets);
		this.reelSetMapper.SetTargets(targets);

		let scatterData =this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown as ScatterRandomAwardResults;
		if(scatterData ){		
			this.scatterRandomAwardFeature?.SetAwards(scatterData.ScattersPositionThisSpin);
			//this.fillingPotUpdate?.Start();			
		}

		if (this.simpleLastBonusAction.Triggers.find(b => b.WillTrigger == true)) {
			let currentindexData = this.simpleAllBonusSpinResult.findIndex((b) => b == this.simpleLastBonusAction);
			let nextBonusData = this.simpleAllBonusSpinResult.find((b, index) => index > currentindexData);
			//let BonusName = this.simpleAllBonusSpinResult.filter(bonus => bonus.Phase == "Start" && bonus.Depth == 1);

			//BonusName.forEach(bonus => {
			let newBonus = this.bonusList.get(nextBonusData.Bonus as Bonus);
			if (!newBonus) throw "No such bonus!";
			this.currentBonus = newBonus;
			nextBonusData = null;
			currentindexData = null;
			//this.runingBonuses = bonusWon.reverse();

			//});
		}
	}

	

	public OnBonusTotalResult(totalResult: BonusTotalResult): void {
		// Log.Debug(this.logGroup, "OnBonusTotalResult(runResult: " + JSON.stringify(totalResult) + ")");
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		// Log.Debug(this.logGroup, "OnBonusFinish(bonusFinish: " + JSON.stringify(bonusFinish) + ")");
	}

	protected bet: SlotGameBet = null;

	//protected bonusStartConfig: IBonusStartConfig = null;
	protected simpleBonusSpin : FreegamesSpinAction [] = null; 
	protected simpleBonusConfig : FreegamesSpinAction = null;
	protected startConfig : FreegamesStartAction = null;
	public Prepare(bonusStartConfig: IBonusStartConfig): void
	{

		this.startConfig = (bonusStartConfig.actions as FreegamesStartAction []).find(b => b.Phase == "Start");
		this.simpleBonusConfig = (bonusStartConfig.actions as FreegamesSpinAction []).find(b => b.Phase == "Start");
		this.simpleBonusSpin = (bonusStartConfig.actions as FreegamesSpinAction []).filter(b => b.Bonus == "FreeGameBonus");
		this.bet = bonusStartConfig.bet;				
		this.spinIndexData = 0 ; 
		this.scatterRandomAwardFeature?.UpdateBet(bonusStartConfig.bet);
		this.scatterRandomAwardFeature?.Start();
		this.simpleAllBonusSpinResult = bonusStartConfig.actions;
		// Log.Debug(this.logGroup, "Prepare() config: ", this.simpleBonusConfig);
		//console.log("ApiResultFG:",simpleAllSpinData);
		this.symbolsAnimation.Stop();
		//this.bonusTriggerAnimation.Stop();
		this.plusOneAnim.ResetCount();
	}


	public HistoryView( actionIndex:number, gameState: SimpleSlotGameState): HTMLElement
	{
		//let gameState : SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState); 		

		let action: FreegamesSpinAction = gameState.Actions[actionIndex]as FreegamesSpinAction;
		let PayTableDivSize:Size =  new Size(20,17);
		
		
		let bonusView: HTMLElement = CreateElement("div",{ classes:["bonusView", "FreeGameHistory"],
				style:
				{
					//width:"100%",
					height: Scale.Hpx(975),
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
				}
		});
		
		// in first action we only get number of picked free games
		if (action.Phase == "Start") {
			CreateElement("div",{
			style: 
			{
				textAlign:"center",
				lineHeight: Scale.fhpx(50),
				fontSize: Scale.fhpx(50),
				width: "100%",
				height: "100%",
				color: "white",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			innerHTML: `FREE GAME START, ${action.SpinsStarted} SPINS AWARDED!`, 
			parentToAppend: bonusView,			
		});

			// let gameView: HTMLElement = CreateElement("div", {
			// 	classes: ["gameBackground"], parentToAppend: bonusView,
			// 	style:
			// 	{
			// 		width: Scale.Wpx(900),
			// 		height: Scale.Hpx(700),
			// 		backgroundRepeat: "no-repeat",
			// 		backgroundSize: "cover",
			// 		backgroundPosition: "center",
			// 		display: "flex",
			// 		flexDirection: "row",
			// 		justifyContent: "center",
			// 		alignItems: "center",
			// 		fontSize: Scale.fhpx(100),
			// 		color: "white",
			// 		backgroundImage: this.gameBackground.CssBackground(),
			// 	}
			// });

			// let pickedFreeGames = CreateElement("div", {
			// 	classes: ["pickedFreeGames"], parentToAppend: gameView,
			// 	style:
			// 	{
			// 		width: Scale.Wpx(300),
			// 		height: Scale.Hpx(300),
			// 		display: "flex",
			// 		justifyContent: "center",
			// 		alignItems: "center",
			// 	}
			// });

			//let pickCanvas: MyCanvas = new MyCanvas(new Size(Scale.H(350), Scale.W(350)));
			// let pickSprite: CanvasSprite = this.canvasSprite;
			//pickCanvas.DrawImage(pickSprite.sprite.IdleFrame, pickSprite.sprite.IdleFrameRect, pickCanvas.rect)

			//pickedFreeGames.appendChild(pickCanvas.view);

			// let awarderFreeGames: HTMLElement = CreateElement("div", {
			// 	classes: ["awarderFreeGames"], parentToAppend: pickedFreeGames, innerHTML: "" + action.SpinsStarted,
			// 	style:
			// 	{
			// 		position: "absolute",
			// 		display: "flex",
			// 		justifyContent: "center",
			// 		alignItems: "center",
			// 		fontSize: Scale.fhpx(100),
			// 		color: "white",
			// 	}
			// });

			return bonusView;

		}
		else if (action.Phase == "Spin" ) {
			let lineWinsCount: number = action.Win.ResultLines.length;
			let lines: LineWin[] = action.Win.ResultLines;
			//let leftSideLines: number = lineWinsCount / 2;
			//let rightSideLines: number = lineWinsCount / 2;



			// // left side lines display
			// {
			// 	let linesLeft: HTMLElement = CreateElement("div", {
			// 		classes: ["linesLeft", this.resid.Add("History").Scope()], parentToAppend: bonusView,
			// 		style:
			// 		{
			// 			width: Scale.Wpx(200),
			// 			height: "100%",
			// 			display: "flex",
			// 			flexDirection: "column",
			// 			justifyContent: "center",
			// 		}
			// 	});

			// 	for (let i = 0; i < leftSideLines; i++) {
			// 		let line = CreateElement("div", {
			// 			classes: ["line", "" + i], parentToAppend: linesLeft,
			// 			style:
			// 			{
			// 				width: Scale.Wpx(131),
			// 				//marginBottom:Scale.XYpx(5),
			// 				display: "flex",
			// 				flexDirection: "row",

			// 			}
			// 		});

			// 		let lineLayout: HTMLElement = CreateElement("div", {
			// 			classes: ["lineLayout"], parentToAppend: line, innerHTML: this.params.slotGame.CreatePlayLines([this.params.slotGameInitData.Playlines[lines[i].LineIndex]], this.params.windowSymbolSize, lines[i].LineIndex, PayTableDivSize),
			// 			style:
			// 			{
			// 				display: "flex",
			// 				justifyContent: "center",
			// 				width: Scale.Hpx(78.59),
			// 			}
			// 		});
			// 		let lineStats = CreateElement("div", {
			// 			classes: ["lineStats"], parentToAppend: line, innerHTML: "" + lines[i].SymbolCount + " X " + lines[i].SymbolID + " " + this.moneyFormatter.FormatCurrency(lines[i].Win),
			// 			style:
			// 			{
			// 				fontSize: Scale.fhpx(10),
			// 				color: "white",
			// 				textAlign: "center",
			// 				width: Scale.Wpx(30),
			// 				display: "flex",
			// 				justifyContent: "flex-start",
			// 				lineHeight: Scale.fhpx(12),
			// 			}
			// 		});
			// 	}
			// }


			let reelView: HTMLElement = null;
			//reel view
			{
				let gameView: HTMLElement = CreateElement("div", {
					classes: ["gameBackground"], parentToAppend: bonusView,
					style:
					{
						width: Scale.Xpx(700),
						height: Scale.Hpx(700),
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						backgroundPosition: "center",
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
						backgroundImage: this.gameBackground,
					}
				});

				// reel view
				reelView = CreateElement("div", {
					classes: ["reelView"], parentToAppend: gameView,
					style:
					{
						width: Scale.Xpx(770),
						height: Scale.Hpx(490),
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}
				});
			}
			

			// all lines display
			{
				let linesAll: HTMLElement = CreateElement("div", {
					classes: ["linesAll", this.resid.Add("History").Scope()], parentToAppend: bonusView,
					style:
					{
						width: "100%",
						height: Scale.Hpx(975),
						display: "flex",
						flexDirection: "row",
						flexWrap: "wrap",
						justifyContent: "center",
					}
				});

				for (let i = 0; i < gameState.Bet.Bet.Lines; i++) {
					let line = CreateElement("div", {
						classes: ["line", "" + i], parentToAppend: linesAll,
						style:
						{
							width: Scale.Wpx(131),
							//marginBottom:Scale.XYpx(5),
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",

						}
					});
					
					let currentWinLine = action.Win.ResultLines.find(a => a.LineIndex == i);
					let lineLayout: HTMLElement = CreateElement("div", {
						classes: ["lineLayout"], parentToAppend: line, innerHTML: this.params.slotGame.CreatePlayLines([this.params.slotGameInitData.Playlines[i]], Size.FromPlayWindow(this.params.windowSymbolSize), i, PayTableDivSize,false), 
						style:
						{
							display: "flex",
							justifyContent: "center",
							width: Scale.Hpx(78.59),
							filter: currentWinLine ? "" : "brightness(50%)",
						}
					});					
					let pays : string = "&nbsp";
					if(currentWinLine)
					{
						pays = "" + currentWinLine.SymbolCount + "×" + currentWinLine.SymbolID + " pays " + service.moneyFormatter.FormatCurrency(currentWinLine.Win);
					}
					let lineStats = CreateElement("div", {
						classes: ["lineStats"], parentToAppend: line, innerHTML: pays,
						style:
						{
							fontSize: Scale.fhpx(12),
							color: "white",
							textAlign: "center",
							width: "100%",
							//display: "flex",
							//justifyContent: "flex-start",
							lineHeight: Scale.fhpx(10),
							margin: Scale.fhpx(3),
						}
					});
				
				}
			}


			for (let i = 0; i < action.SpinWithFeatures.ReelRowExpectedSymbols.length; i++) {
				for (let j = 0; j < action.SpinWithFeatures.ReelRowExpectedSymbols[i].length; j++) {

					//console.log("Symbols Expected",spinAction.Spin.ExpectedSymbols[i][j] )
					let symbol = this.params.symbolSpriteAnimsByName.get(action.SpinWithFeatures.ReelRowExpectedSymbols[i][action.SpinWithFeatures.ReelRowExpectedSymbols[i].length - j - 1]);

					let canvas: MyCanvas = this.historySpinableReels.canvas[i][j];
					symbol.Draw(canvas);
					//console.log("Symbols Expected", )

					let scatterRandomAwardResult: ScatterRandomAwardResult = (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)



					if (scatterRandomAwardResult != null) {

						let AwardOptionPosition = scatterRandomAwardResult.ScattersPosition as AwardOptionPosition[];
						console.log(`Checking col ${j} row ${i}: `, scatterRandomAwardResult);
						

						let scatterPosition = AwardOptionPosition.find(s => i == s.Col && action.SpinWithFeatures.ReelRowExpectedSymbols[i].length - j - 1 == s.Row);
						if (scatterPosition != null) {

							this.scatterRandomAwardFeature?.GetHistoryValueCanvas({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: canvas
							});
						}
					}
				}

			}
			reelView.appendChild(this.historySpinableReels.GetView());


			return bonusView;
		}
		else if (action.Phase == "End") {

			let gameView: HTMLElement = CreateElement("div", {
				classes: ["gameBackground"], parentToAppend: bonusView,
				style:
				{
					width: Scale.Wpx(900),
					height: Scale.Hpx(700),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					backgroundImage: this.gameBackground,
				}
			});

			let endAction = gameState.Actions[actionIndex] as FreegamesEndAction;
			gameView.style.flexDirection = "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width: "100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "rgba(0,0,0,0.5)",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,
					backgroundImage: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				}
			});
			winView.innerText = service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)



			return bonusView;
		}


		
		return null;
	}	

	public HistoryStats2( actionIndex:number,  gameState : SimpleSlotGameState): ActionStats
	{
		let action: FreegamesSpinAction = gameState.Actions[actionIndex] as FreegamesSpinAction;
		
		// let actionStats: HTMLElement = CreateElement("div", {
		// 	style:
		// 	{
		// 		width:"100%",
		// 		height:"100%",
		// 	}
		// });
		
		if(action.Phase == "Start")
		{
			return {
				Bonus : action.Bonus, 
				Action : action.Action, 
				Stats : [{key: "Runs started", value: service.moneyFormatter.FormatQuantity(action.SpinsStarted)}]
			}	
			
			// let pickedFreeGames = CreateElement("div", {classes:["pickedFreeGames"], innerHTML: "Starting freeGames: " + action.NumFreegames, parentToAppend:actionStats });
			// return actionStats;
		}
		else if(action.Phase == "Spin")
		{
			// let lineWins: number = action.LineWins.length;
	
			// let runsPlayed = CreateElement("div", {classes:["runsPlayed"], innerHTML: "Runs Played: " + action.PlayedFreegames, parentToAppend:actionStats });
			// let runsRemaining = CreateElement("div", {classes:["runsRemaining"], innerHTML: "Runs Remaining: " + action.RemainingFreegames, parentToAppend:actionStats });
			// let gameLineWins = CreateElement("div", {classes:["gameLineWins"], innerHTML:"# Wining lines: "+ lineWins , parentToAppend:actionStats });
			// let runWin = CreateElement("div", {classes:["runWin"], innerHTML:"Current run win: "+ this.moneyFormatter.FormatCurrency(action.RunWin.InCents), parentToAppend:actionStats });
			// let winUpToNow = CreateElement("div", {classes:["winUpToNow"], innerHTML:"Total bonus win: "+ this.moneyFormatter.FormatCurrency(action.WinUpToNow.InCents), parentToAppend:actionStats });
			// let BonusTriggered = CreateElement("div",{classes:["bonusTriggered"], innerHTML:"Bonus: "+ action.TriggeredBonus, parentToAppend:actionStats});

			return {		
				Bonus : action.Bonus,
				Action : action.Action,
				Stats : [
				{key: "Runs started", value: service.moneyFormatter.FormatQuantity(action.SpinsStarted)},
				{key: "Runs played", value: service.moneyFormatter.FormatQuantity(action.SpinsPlayed)},
				{key: "Runs remaining", value: service.moneyFormatter.FormatQuantity(action.SpinsRemaining)},
				{key: "Current run win", value: service.moneyFormatter.FormatCurrency(action.WinAmounts.TotalWin.InCents)},
				{key: "Total bonus win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents)},
				]
			}
		}
		else if (action.Phase == "End"){
			let actionEnd: FreegamesEndAction = gameState.Actions[actionIndex] as FreegamesEndAction;
			return {
				Bonus : action.Bonus,
				Action : action.Action,		
				Stats : [
				{key: "Bonus Win", value: service.moneyFormatter.FormatCurrency(action.WinSinceBonusStart.TotalWin.InCents)},
				{key: "Total Win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents)},
				]
			}
		}
		
		return null;
	}

	// public PixiCanvasCrash(): void {
	// 	console.log("PIXI destroyed FreeGames:", this.gameName);
	// 	this.spinnableReels.ForceContextCrash();
	// }

	public ReelsRestored() {
		this.reelElement = this.spinnableReels.ReelElements;
		this.reelMask = this.spinnableReels.ReelWindowMask;
		this.RedrawAllReels();
	}

	protected RedrawAllReels() {

		for (let i = 0; i < this.spinnableReels.GetWindowSymbolSize().Width; i++) {
			this.RedrawReel(i);
		}
	}

	// public DestroyPixi() {
	// 	this.spinnableReels.Destroy();
	// 	//console.log("PIXI destroyed FreeGames:", this.gameName);
	// }

	public ReCreatePixiReels() {
		
		console.log("PIXI start recreated FreeGameBonus:", this.gameName);
	}

	public async GameSelected()
	{
		//this.spinnableReels.Create();
		if (Settings.fillingPotFeature == FillingPotFeature.Disable){
			this.spinnableReels.Create();
		}
		if (Settings.fillingPotFeature == FillingPotFeature.Enable){
			await this.fillingPotFeature?.Create();
			this.shakeAnimation.CreateShakeAnimationPixi(this.fillingPotFeature?.GetReelContainer());
		}
	}

	public GameExit()
	{
		//this.spinnableReels.Destroy();
		if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
			this.spinnableReels.Destroy("FreeGameBonus.GameExit");
		} else {
			this.fillingPotFeature?.Destroy();
		}
	}

	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		this.reelSpinAnimation.forEach(animation => {
			animation.UpdateSpinSpeed(changeSpeedParams.SpinParams)
		});
	}

	public override SharedJackpotWin(win: SharedJackpotWin) {		
		//this.jackpotSharedShow?.ShowShared(win);		
	}
}

export interface IFreegameBonusPickElementFactory
{
	CreatePickElement(params: FreegamePickElementParams): FreegamePickElement;
}

export interface IFreegameBonusFactory
{
	CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus;
	CreateFreegameBonusPIXIAPP(gameName: string, params: FreegameBonusParams): FreegameBonusPIXIAPP;
	CreateFreegameBonusPIXIAPPResponsive(gameName: string, params: FreegameBonusParams): FreegameBonusPIXIAPPResponsive;
}

export interface IFreegameBonusAndPickElementFactory extends
	IFreegameBonusPickElementFactory,
	IFreegameBonusFactory
{

}

export class FreegameBonusFactory implements IFreegameBonusAndPickElementFactory
{
	public CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus
	{
		return new FreegameBonus(gameName, params);
	}
	public CreateFreegameBonusPIXIAPP(gameName: string, params: FreegameBonusParams): FreegameBonusPIXIAPP
	{
		return new FreegameBonusPIXIAPP(gameName, params);
	}
	public CreateFreegameBonusPIXIAPPResponsive(gameName: string, params: FreegameBonusParams): FreegameBonusPIXIAPPResponsive {
		return new FreegameBonusPIXIAPPResponsive(gameName, params);
	}

	public CreatePickElement(params: FreegamePickElementParams): FreegamePickElement
	{
		return new FreegamePickElement(params);
	}
}
